/** React components  */
import React, { useState, useEffect, useRef, useContext } from 'react';
import cn from 'classnames';

/** To custom event handling */
import EventEmitter from 'react-native-eventemitter';

/** To animating views easily */
import { Animated } from 'react-animated-css';

import CustomPaginator from '../../../components/CustomPaginator';
import MassiveTimelineView from '../../../components/MassiveTimelineView';

/** import library for handle dates */
import 'moment/locale/es';

/** import library for format numbers */
import indicatorIcon from '../../../assets/img/indicators/indicator.svg';
import moment from 'moment';
import * as Sentry from '@sentry/react';

/** Build components from antd css framework */
import {
  Row,
  Col,
  Switch,
  Spin,
  Icon,
  Empty,
  DatePicker,
  Tooltip,
  message,
  Input,
  Button,
  Modal
} from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import CardTask from '../../../components/CardTask';
import { PdfIcon } from '../../../icons';
import ModalSystem from '../../../components/DesignSystem/ModalSystem';
import DatePickerSystem from '../../../components/DesignSystem/DatePickerSystem';
import DropdownSystem from '../../../components/DesignSystem/DropdownSystem';
import './index.scss';

import ConstraintForm from '../../../components/LookAhead/Constraints/ConstraintForm';
import { withTranslation } from 'react-i18next';
import useWindowDimensions from '../../../hooks/useWindowDimensions';
/** Services */
import { activityService } from '../../../services/activity.service';
import { historicalActivityProgressService } from '../../../services/historicalactivityprogress.service';
import { userService } from '../../../services/user.service';
import { taskService } from '../../../services/task.service';
import { viewService } from '../../../services/views.service';
import {
  activityModificationService,
  calendarService,
  sectorService,
  subContractService,
  tagService
} from '../../../services';
import { base } from '../../../services/base';
import ModalAddTags from '../../../components/Settings/ModalAddTags';
import {
  getFlattenActivities,
  openNotification,
  handshake,
  belongsToRange,
  excludeDeep,
  getTodayWeekWithPday,
  fieldsOnlyForGanttView
} from '../../../utils';
import ModalAddSubContract from '../../../components/Settings/ModalAddSubContract';

import calendarModificationIconModal from '../../../assets/img/activitymodification/calendar-modal.png';

/** Redux */
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { lookaheadActions } from '../../../redux/actions/lookaheadActions';
import { userActions } from '../../../redux/actions/userActions';
/** JSON with table distribution */
import { tableMetadata } from './table.layout';

/** Single table with activity as header and tasks as childs */
import LookaheadActivity from '../../../components/LookaheadActivity';
import {
  buildActivityMap,
  buildTaskMap,
  defaultGanttFields,
  massiveUnselected,
  updateAsyncTaskHelperHackSet,
  updateRenderHelperHackSet
} from '../../../components/GanttVisualization/GanttVisualization.helper';

import { Gantt as GanttDhtmlx } from '../../../assets/gantt/dhtmlxgantt';

import GanttVisualization from '../../../components/GanttVisualization';
import TaktVisualization from '../../../components/TaktVisualization';
import LookaheadOtherGroup from '../../../components/LookaheadOtherGroup';
import ModalAddResources from '../../../components/ModalAddResources';

/** Header with filters options component */
import LookaheadFilterHeader from '../../../components/LookaheadFilterHeader';

/** Function to clone objects on JS */
import cloneDeep from 'lodash/cloneDeep';
import differenceBy from 'lodash/differenceBy';

/** Function to keep states replacing specific elements */
import update from 'immutability-helper';
import { firstBy } from 'thenby';

import {
  convertPPActivity2PluginTask,
  recursiveTransformForTasks,
  obtainKeyValuesOfArray
} from './index.helper';
import {
  calculatePonderators,
  getTask,
  notifyMessage,
  defineDateUnfit,
  defineTitleModification,
  diffTableConfigColumns,
  calculateLeanStatus,
  resizeNameTaskColumn,
  handleLeanStatusColPosition,
  getFlattenTasks,
  leanStatusArray,
  calculateExpectedCost,
  calculateExpectedForWeek
} from '../../../utils/lookahead-common';
import { ganttAPI } from '../../../utils/customGanttPlugin';
import { dynamicSort } from '../../../utils';

import { socket } from '../../../services/socket.service';

import AnimatedSortable from '../../../components/AnimatedSortable';
import { projectService } from '../../../services/project.service';
import { viewType } from './index.helper';
import { isFeatureOn } from '../../../utils/featureUtils';

import ActivityTreePane from '../../../components/ActivityTreePane/ActivityTreePane';

import { ViewsCtx } from '../../../Context/Planification/ViewsContext';
import useSubtradeUser from '../../../hooks/useSubtradeUser';
import { timelineActions } from '../../../redux/actions/lookaheadTimelineActions';
import { transformHourToDays } from '../../ganttContainer/gantt/gantt.helper';

import { trackingEvent } from '../../../analytics';
import { AMPLITUDE_SERVICE } from '../../../analytics/constants';
import { getBasicAmplitudEventProperties } from '../../../analytics/utils';
import { NUMWEEKSPERPAGE } from '../../../components/Report/LookAHeadReport';

import { WarningDiamontIcon } from '../../../icons';
import {
  totangoEventTracking,
  totangoSetAccountAttributes
} from '../../../analytics/implements/totango';
import { getSignedUser } from '../../../utils/userUtils';
import ExportPdfModal from '../../../components/ExportPdfModal/ExportPdfModal';
import ModalMessage from '../../../components/ExportablePDFMessage/ModalMessage';

import { useWorker } from '../../../hooks/useWorker'
import { useLookaheadDailyPdfExportValidation } from './hooks/useLookaheadDailyPdfExportValidation';
import { TimerManagerSingleton } from '../../../utils/timerManager';
import notificationSystemV2 from '../../../components/DesignSystem/NotificationSystemV2/NotificationSystemV2';
import { clearCaches } from '../../../components/GanttVisualization/columns/progress/utils';

/** RangePicker builded components to use datepicker from start to end in just one input :)  */
const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;

const { TextArea } = Input;

export const TestIds = {
  PLANIFICATION_CONTAINER: 'planification_container'
};

/**
 * This view shows activities from last level.
 * Then user can through a filter change range date showed.
 * Then, user can add on eagger data model tasks, associating them with the activity ID as a super parent.
 * @param {*} props
 */
function PlanificationView({
  permission = {},
  t = () => '',
  history = {},
  setContainerHeader = () => { }
}) {
  /*********************************/
  /** Component variables section */
  /*******************************/
  const subtradeRole = useSubtradeUser();
  const {
    ganttObject: [__, setGanttCtx]
  } = useContext(ViewsCtx);
  const listView = useRef([]);
  const columnTimelineMoved = useRef(false);
  const defaultView = useRef({});
  window.listView = listView
  window.defaultView = defaultView
  const leanStatusColVisibility = useRef(null);
  const timerManager = TimerManagerSingleton.getInstance();

  const [activeActivityTreePane, setActiveActivityTreePane] = useState(false);
  const [activitiesTreePanel, setActivitiesTreePanle] = useState([]);

  const [refresh, setRefresh] = useState([true]);
  const [currentPage, setCurrentPage] = useState(0);
  const [modalModification, setModalModification] = useState({
    visible: false,
    title: '',
    description: '',
    data: { activity: {}, task: {} }
  });

  const [scrollTaktPosition, setScrollTaktPosition] = useState({
    top: 0,
    left: 0
  });
  const [isShowPreview, setIsShowPreview] = useState(false);

  /** Tags stuff */
  const [toSelectTags, setToSelectTags] = useState([]);
  const [visibleFormTags, setVisibleFormTags] = useState(false);
  const [reloadTagsArray, setReloadTagsArray] = useState(true);
  const timelineState = useSelector((state) => state.timelineState);
  window.timelineState = timelineState
  const [popsVisibility, setPopsVisibility] = useState({});
  const [realTimePings, setReaTimePings] = useState([]);

  const [activityTreePaneSettigns, setActivityTreePaneSettings] = useState({});

  /** hooks card */
  const [cardState, setCardState] = useState({ visible: false });
  const [currentTask, setCurrentTask] = useState(null);
  const [currentActivity, setCurrentActivity] = useState(null);
  const [resourcesCard, setResourcesCard] = useState([]);
  const [lastLevelActivitiesCard, setLastLevelActivitiesCard] = useState({});
  const [currentWeekWithPday, setCurrentWeekWithPday] = useState();

  /** hooks indicator */
  const [indicatorVisible, setIndicatorVisible] = useState(false);
  const [indicators, setIndicators] = useState(false);
  const [indicatorPercentage, setIndicatorPercentage] = useState(false);
  const [isLookaheadFullLoaded, setIsLookaheadFullLoaded] = useState(false);

  /** massive process connect with gantt */
  const [massiveSelectionGannt, setMassiveSelectionGannt] = useState({});

  /** handle Form Add Constraint */
  const [visibleForm, setVisibleForm] = useState({ value: false, tasks: [] });
  const [ganttData, setGanttData] = useState({ data: [], links: [] });

  /** Project state from redux */
  const projectState = useSelector((state) => state.projectState);
  const projectSectorSelected = useSelector(
    (state) => state.projectState?.sectorSelected
  );
  const projectIdSelected = useSelector(
    (state) => state.projectState?.projectSelected
  );
  const companyState = useSelector((state) => state.companyState);
  const noRequireResources = !companyState?.currentCompany?.require_resources;
  const lookaheadState = useSelector((state) => state.lookaheadState);
  const dispatch = useDispatch();
  const [ganttLoaded, setGanttLoaded] = useState(false);

  const [existFilter, setExistFilter] = useState(false);

  /** Activities to handle table loading */
  const [activities, setActivities] = useState([]);
  const [isTree, setIsTree] = useState({ value: true });

  /** Calendar to handle table loading */
  const [calendars, setCalendars] = useState([]);

  /** Array with users that belongs to the same sector that this master plan */
  const [toSelectResponsables, setToSelectResponsables] = useState([]);
  const [tags, setTags] = useState([]);

  /** Flag to know when component is on loading step */
  const [isLoading, setLoading] = useState(true);
  const [isReloadDataViews, setReloadDataViwes] = useState(true);

  const [changeVisualization, setChangeVisualization] = useState(false);

  /** Object to handle start and end dates to show last level activities from master plan  */
  const [dateRange, setDateRange] = useState({ start: '', end: '' });

  const [taktRelations, setTaktRelations] = useState([]);

  const [groupBy, setGroupBy] = useState({
    criteria: 'activityId',
    sort: 'asc'
  });

  /** Variable to view and his components to handle table manipulation by user */
  const [tableConfig, setTableConfig] = useState([]);

  const [resizing, setResizing] = useState(false);

  const [massiveSelection, setMassiveSelection] = useState([]);

  const { height, width } = useWindowDimensions();

  const [scrollStates, setScrollStates] = useState({});

  const [massiveOnProcess, setMassiveOnProcess] = useState(false);
  const [gantt, setGantt] = useState(null);
  const [shoudlDestroyGantt, setShouldDestroyGantt] = useState(false);
  const [activityResource, setActivityResource] = useState(null);
  const [taskSelected, setTaskSelected] = useState();
  const [visibleFormResource, setVisibleFormResource] = useState(false);

  const [subContracts, setSubcontracts] = useState([]);
  const [subContractsReload, setSubcontractsReload] = useState(false);
  const [visibleFormSubcontract, setVisibleFormSubcontract] = useState(false);
  const [typeResource, setTypeResource] =
    useState('material'); /** material, machinery, rrhh */

  /** Full width feature */
  const [totalTablesWidth, setTotalTablesWidth] = useState(0);
  let paginatorRef = useRef();
  const currentActivities = useRef([]);
  const [tableUpdated, setTableUpdated] = useState(false);
  const [geo_project_id, setGeo_project_id] = useState(null);
  const [geo_users, setGeo_users] = useState(null);

  // Modal pla
  const [modelReportLookAhead, setModelReportLookAhead] = useState(false);
  const [modelReportDateLookAhead, setModelReportDateLookAhead] = useState(
    moment(new Date(), 'YYYY/MM/DD').format('YYYY/MM/DD')
  );
  const [numWeeks, setNumWeeks] = useState(NUMWEEKSPERPAGE);
  const [sectorObject, setSectorObject] = useState(false);

  const [array, setArray] = useState([]);
  const [ReloadTableUsers, setReloadTableUsers] = useState(true);
  const [isLWP18, setIsLWP18] = useState(false);

  // Modal export PDF
  const [isExportPdfModalVisible, setIsExportPdfModalVisible] = useState(false);
  const [isShowFitToOnePageModal, setIsShowFitToOnePageModal] = useState(false);

  /** set hour min y max */
  const [customHour, setCustomHour] = useState({ startHour: '', endHour: '' });

  const [resourceOptions, setResourceOptions] = useState({
    materials: [],
    machineries: [],
    specialties: []
  });

  const [refreshResourceForGantt, setRefreshResourceForGantt] = useState(true);
  const [isWeeklyCommited, setIsWeeklyCommited] = useState({
    commited: false
  });
  const [volatileTaskData, setVolatileTaskData] = useState({});
  const [getLookaheadInMassive, setGetLookaheadInMassive] = useState({});

  const [defaultViewCreated, setDefaultViewCreated] = useState(false);
  const isBuildingViews = useRef(false);

  const [activitiesHidden, setActivitiesHidden] = useState([]);
  const [currentActivityHidden, setCurrentActivityHidden] = useState();

  const allActivitiesRef = useRef([]);
  const firstLoad = useRef(true);
  window.firstLoad = firstLoad;

  const config = {
    sector_id: projectState.sectorSelected,
    start: modelReportDateLookAhead,
    end: moment(modelReportDateLookAhead)
      .add(numWeeks * 7 - 1, 'days')
      .format('YYYY/MM/DD')
  };

  const {
    isLoadingPdf,
    setLoadingPdf,
    isShowAlertEmpty,
    isErrorForm,
    setIsErrorForm,
    validateAndNavigate
  } = useLookaheadDailyPdfExportValidation({
    activities,
    modelReportDateLookAhead,
    numWeeks,
    defaultView,
    history,
    config
  });

  /********************/
  /** Effects section */
  /******************/

  useEffect(() => {
    dispatch(
      timelineActions.setInitialFlagData({
        value: false,
        lastProjectSelected: projectState.projectSelected,
        sectorSelected: projectState.sectorSelected
      })
    );

    updateAsyncTaskHelperHackSet(updateAsyncActivity);
    updateRenderHelperHackSet(() => updateRender);

    return () => {
      clearCaches();
    };

  }, []);

  const handleChangeSectorOrProject = async () => {
    if (!projectState && !projectState.sectorSelected) return;
    const sectorResActivity =
      await sectorService.createActivitiesTreeForActivityTree(
        projectState.sectorSelected
      );
    setActivitiesTreePanle(sectorResActivity.sector);
    if (!timelineState) return;
    if (!lookaheadState.forceLoadingSector)
      dispatch(lookaheadActions.setForceLoadingSector(true));
    if (window.ganttVisualization) {
      // window.ganttVisualization.clearAll()
      if (
        timelineState.lastProjectSelected !== projectState.projectSelected ||
        timelineState.sectorSelected !== projectState.sectorSelected
      ) {
        dispatch(
          timelineActions.setInitialFlagData({
            value: false,
            lastProjectSelected: projectState.projectSelected,
            sectorSelected: projectState.sectorSelected
          })
        );
      }
    }
    if (!lookaheadState.forceLoadingSector)
      dispatch(lookaheadActions.setForceLoadingSector(false));
  };

  const resourceColumns = [
    'materialId',
    'machineId',
    'specialtyId',
    'total_quantity',
    'actual_quantity',
    'remaining_quantity',
    'won_hh',
    'spend_hh',
    'total_hm',
    'spend_hm',
    'quantity_parcial',
    'hhWorkTime'
  ];

  const availableTableMetadata = noRequireResources
    ? tableMetadata.filter((item) => !resourceColumns.includes(item.name))
    : tableMetadata;

  /** This efect detects when a tag was added, and updates it state */
  useEffect(() => {
    if (tableConfig.length) {
      if (reloadTagsArray) {
        getTags();
      }
    }
  }, [reloadTagsArray]);

  useEffect(() => {
    if (isFeatureOn('enable_lwp_18')) {
      setIsLWP18(true);
    }
  }, []);

  /** Effect to load translation to table declaration file */
  useEffect(() => {
    const loggedUser = getSignedUser();
    const currentCompany = companyState?.currentCompany;
    const project = projectState.allProjects.find(
      (p) => p.id == projectState.projectSelected
    );

    if (!loggedUser) return;

    totangoSetAccountAttributes(
      loggedUser,
      projectState.projectSelected,
      currentCompany?.name,
      currentCompany?.id,
      project?.name,
      project?.stage,
      project?.country
    );

    totangoEventTracking(
      `p_${projectState.projectSelected}`,
      loggedUser,
      'See Lookahead',
      'Lookahead'
    );

    const todayWeek = getTodayWeekWithPday(projectState);
    if (!todayWeek) return;
    setCurrentWeekWithPday(todayWeek);

    window.Appcues.page();
  }, []);

  useEffect(() => {
    gantt && setGanttCtx(gantt);
  }, [gantt]);

  useEffect(() => {
    setDefaultViewCreated(false);
  }, [projectState.projectSelected, projectState.sectorSelected]);

  useEffect(() => {
    buildIndicators();
  }, [activities, indicatorVisible]);

  useEffect(() => {
    if (activityTreePaneSettigns.activitieIds) {
      defaultView.current.activityTreeSettings = activityTreePaneSettigns;
      const idxView = listView.current.findIndex(findView);
      listView.current[idxView].view.activityTreeSettings = {
        ...defaultView.current.activityTreeSettings
      };
    }
  }, [activityTreePaneSettigns]);

  useEffect(() => {
    defaultView.current?.filter_query?.value?.length && setExistFilter(true);
  }, [defaultView.current]);

  useEffect(() => {
    setActiveActivityTreePane(!defaultView.current.activityTreeSettings);

    defaultView.current.colorSchema = 'subcontract';
  }, [defaultView.current]);

  useEffect(() => {
    if (defaultView.current.activityTreeSettings) {
      const hiddenActivities = defaultView.current.activityTreeSettings?.hiddenActivitiesByActions || [];
      const convertedActivities = hiddenActivities.map(activity => 
        typeof activity === 'string' ? parseInt(activity, 10) : activity
      );
      
      setActivitiesHidden(convertedActivities);
    }
  }, [defaultView.current]);
  /** Effect to load translation to table declaration file */

  async function getTableData() {
    const project = await projectService.show(projectIdSelected);
    // setGeo_project_id(project.project.geo_project_id);
    const copyOfTableData = [...availableTableMetadata];

    copyOfTableData.forEach((col) => {
      const originalCol = availableTableMetadata.find(
        (colFromTableFile) => colFromTableFile.name == col.name
      );
      if (originalCol) {
        col.template = originalCol.template;
        col.calculated = originalCol.calculated;
        col.editor = originalCol.editor;
      }
    });
    // const copyOfTableData = [...tableMetadata]

    copyOfTableData.forEach((column) => {
      if (
        column.data_type &&
        (column.data_type.includes('/icon') ||
          column.data_type.includes('/string'))
      ) {
        column.label = t('tables.lookahead.plan.' + column.name + '.label');
        column.from_values.map((option) => {
          option.label = t(
            'tables.lookahead.plan.' + column.name + '.options.' + option.value
          );
        });
      } else {
        column.label = t('tables.lookahead.plan.' + column.name);
      }
    });

    setTableConfig(copyOfTableData);
    setTableUpdated(true);

    /* if (project.project.geo_project_id != null) {
                const d = {
                    projectState: project.project.id
                }
                const geo_users_data = await geoVictoriaService.getGeoUsersData(d);
                setGeo_users(geo_users_data)
            } */
  }

  useEffect(() => {
    if (subContractsReload) {
      const getDataSub = async () => {
        setSubcontracts([]);
        const subcontractsGet = await subContractService.getByProject(
          projectState.projectSelected
        );
        if (subcontractsGet) {
          const typeFrom = { from_values: [] };

          // const typeFrom = tableConfig.find(col => col.name == 'subcontractId')
          // typeFrom.from_values.splice(0, typeFrom.from_values.length)
          const subContractsOrdered = subcontractsGet.subcontracts.sort(
            dynamicSort('name')
          );
          subContractsOrdered.map((type, index) => {
            typeFrom.from_values.push({
              value: type.id,
              label: type.name,
              weigth: index + 1
            });
          });

          setSubcontracts(subContractsOrdered);
          updateSubContractGanttView(subContractsOrdered, gantt);
          setSubcontractsReload(false);
        }
      };
      getDataSub();
    }
  }, [subContractsReload]);

  useEffect(() => {
    if (tableConfig.length) {
      const getData = async () => {
        const subcontractsGet = await subContractService.getByProject(
          projectState.projectSelected
        );
        if (subcontractsGet) {
          const typeFrom = { from_values: [] };

          // const typeFrom = tableConfig.find(col => col.name == 'subcontractId')
          // typeFrom.from_values.splice(0, typeFrom.from_values.length)

          const subContractsOrdered = subcontractsGet.subcontracts; // .sort(dynamicSort('name'));
          subContractsOrdered.map((type, index) => {
            typeFrom.from_values.push({
              value: type.id,
              label: type.name,
              weigth: index + 1
            });
          });

          let tableUserConfig = defaultView.current.columns_json.settings;
          const dateStart = dateRange.start;
          const dateEnd = dateRange.end;
          const ids = defaultView.current?.view?.activityTreeSettings
            ?.activitieIds.length
            ? defaultView.current.view.activityTreeSettings.activitieIds.map(
              (activity) =>
                isNaN(activity) ? JSON.parse(activity).id : activity
            )
            : [];

          const activitiesIds = {
            sector_id: projectState.sectorSelected,
            ids: ids
          };

          setGetLookaheadInMassive({
            ...activitiesIds,
            include_milestone: true
          });

          const lastLevelActivities = isFeatureOn('enable-LWP-103')
            ? await activityService.getLookahead({
              sector_id: projectState.sectorSelected,
              start: dateStart,
              end: dateEnd,
              include_milestone: true
            })
            : await activityService.getLookaheadIds({
              ...activitiesIds,
              include_milestone: true
            });

          const resources = lastLevelActivities.resource || [];
          /** Connect resources data with current view and it's configuration */
          const materialFrom = tableUserConfig.find(
            (col) => col.identifier == 'material'
          );
          const machineryFrom = tableUserConfig.find(
            (col) => col.identifier == 'machinery'
          );
          const specialityFrom = tableUserConfig.find(
            (col) => col.identifier == 'rrhh'
          );

          materialFrom &&
            materialFrom.from_values &&
            materialFrom.from_values.splice(0, materialFrom.from_values.length);
          machineryFrom &&
            machineryFrom.from_values &&
            machineryFrom.from_values.splice(
              0,
              machineryFrom.from_values.length
            );
          specialityFrom &&
            specialityFrom.from_values &&
            specialityFrom.from_values.splice(
              0,
              specialityFrom.from_values.length
            );

          resources.map((resource, index) => {
            const toPush = {
              value: resource.id,
              label: resource.name,
              weigth: index + 1,
              plain: resource
            };

            switch (resource.type) {
              case 'material':
                materialFrom.from_values.push(toPush);
                break;
              case 'machinery':
                machineryFrom.from_values.push(toPush);
                break;
              case 'rrhh':
                specialityFrom.from_values.push(toPush);
                break;
            }
          });

          tableUserConfig = copyColumnTemplate(tableUserConfig, typeFrom);
          setTableConfig(tableUserConfig);
          setSubcontracts(subContractsOrdered);
          updateSubContractGanttView(subContractsOrdered, gantt);
        }
      };
      if (ReloadTableUsers) {
        getData();
      }
    }
  }, [ReloadTableUsers]);

  const updateResources = async () => {
    if (!tableConfig.length) return;
    // eslint-disable-next-line prefer-const
    let tableUserConfig = defaultView.current.columns_json.settings;
    const dateStart = dateRange.start;
    const dateEnd = dateRange.end;
    const lastLevelActivities = await activityService.getLookahead({
      sector_id: projectSectorSelected,
      start: dateStart,
      end: dateEnd
    });
    const resources = lastLevelActivities.resource || [];
    /** Connect resources data with current view and it's configuration */
    const materialFrom = tableUserConfig.find(
      (col) => col.identifier == 'material'
    );
    const machineryFrom = tableUserConfig.find(
      (col) => col.identifier == 'machinery'
    );
    const specialityFrom = tableUserConfig.find(
      (col) => col.identifier == 'rrhh'
    );

    materialFrom &&
      materialFrom.from_values &&
      materialFrom.from_values.splice(0, materialFrom.from_values.length);
    machineryFrom &&
      machineryFrom.from_values &&
      machineryFrom.from_values.splice(0, machineryFrom.from_values.length);
    specialityFrom &&
      specialityFrom.from_values &&
      specialityFrom.from_values.splice(0, specialityFrom.from_values.length);

    resources.map((resource, index) => {
      const toPush = {
        value: resource.id,
        label: resource.name,
        weigth: index + 1,
        plain: resource
      };

      switch (resource.type) {
        case 'material':
          materialFrom.from_values.push(toPush);
          break;
        case 'machinery':
          machineryFrom.from_values.push(toPush);
          break;
        case 'rrhh':
          specialityFrom.from_values.push(toPush);
          break;
      }
    });

    setResourceOptions({
      materials: materialFrom?.from_values || [],
      machineries: machineryFrom?.from_values || [],
      specialties: specialityFrom?.from_values || []
    });
  };

  useEffect(() => {
    updateResources();
  }, [refreshResourceForGantt]);

  useEffect(() => {
    if (!gantt) return;
    let identifier = '';
    const idToArrayMap = {
      machineId: {
        options: resourceOptions.machineries,
        id: gantt.toHardAssignMachine
      },
      specialtyId: {
        options: resourceOptions.specialties,
        id: gantt.toHardAssignSpecialty
      }
    };
    if (gantt.toHardAssignMachine || typeResource === 'machinery') {
      identifier = 'machineId';
    } else if (gantt.toHardAssignSpecialty || typeResource === 'rrhh') {
      identifier = 'specialtyId';
    }

    if (gantt) {
      const idToAssignLast = idToArrayMap[identifier]?.id;
      if (!idToAssignLast) return;
      const objectTask = gantt.getTask(idToAssignLast);
      let lastId = 0;
      let lastObject;
      idToArrayMap[identifier] &&
        idToArrayMap[identifier].options.forEach(({ plain }) => {
          if (plain?.id > lastId) {
            lastId = plain.id;
            lastObject = plain;
          }
        });
      gantt.updateTask(idToAssignLast);
      // gantt.changeVisualizationOption()

      if (gantt.toHardAssignMachine) {
        delete gantt.toHardAssignMachine;
      } else if (gantt.toHardAssignMaterial) {
        delete gantt.toHardAssignMaterial;
      } else if (gantt.toHardAssignSpecialty) {
        delete gantt.toHardAssignSpecialty;
      }
      /** gantt state update */
      objectTask[identifier] = lastId;

      /** View local state update and ProPlanner DB update */
      const activityRef = activities.find(
        (ac) => ac.unique_id == objectTask.activityReference.id
      );
      if (activityRef) {
        /** update task data */
        const doesExistAtReference = getTask(idToAssignLast, null, activityRef);
        if (doesExistAtReference.length) {
          const reference = doesExistAtReference[0];
          reference[identifier] = lastId;
          updateAsyncTask(reference);
        }
      }
    }
  }, [resourceOptions]);

  useEffect(() => {
    dispatch(lookaheadActions.notifyLookaheadUpdateGroup());


    const notifyLookaheadUpdateOrderCallback = () => {
      dispatch(lookaheadActions.notifyLookaheadUpdateOrder());
    };
    timerManager.registerAutoTimeout(
      notifyLookaheadUpdateOrderCallback,
      50,
      'notifyLookaheadUpdateOrder1'
    );


    const notifyLookaheadUpdateFilterCallback = () => {
      dispatch(lookaheadActions.notifyLookaheadUpdateFilter());
    };
    timerManager.registerAutoTimeout(
      notifyLookaheadUpdateFilterCallback,
      100,
      'notifyLookaheadUpdateFilter1'
    );
  }, [lookaheadState.notifyChange]);

  useEffect(() => {
    if (!isLoading) {
      setArray([renderGeneralHeader(), ...activities]);
    }
  }, [isLoading]);

  useEffect(() => {
    const ganttDestroy = async () => {
      if (shoudlDestroyGantt) {
        setLoading(true);
        window.location.reload(false);
      }
    };

    ganttDestroy();
  }, [shoudlDestroyGantt]);

  useEffect(() => {
    if (calendars && gantt) {
      if (defaultView.current.name == 'gantt') {
        ganttLoaded && loadCalendars(calendars);
        return;
      }

      loadCalendars(calendars);
    }
  }, [calendars, gantt, ganttLoaded]);

  /** use effect to set hours according shifts */
  useEffect(() => {
    if (Object.keys(calendars).length !== 0) {
      const calendarDefault =
        calendars && calendars.find((el) => el.is_default);
      if (calendarDefault) {
        const currentProject = projectState.allProjects.find(
          (el) => el.id === projectState.projectSelected
        );

        const shifts = calendarDefault.shifts;
        const shiftOrdered = shifts.sort(dynamicSort('correlative_id', true));

        /** get shifts */
        const firstShift = shiftOrdered[0].shift_string;
        const lastShift = shiftOrdered[shiftOrdered.length - 1].shift_string;

        /** get planification day - 1, until this != false */
        let subtractPlanificationDay =
          currentProject.planification_day - 1 < 0
            ? 6
            : currentProject.planification_day - 1;

        /** calculate ini */
        const shiftArr = firstShift.split('-');
        const firstHourArr = shiftArr[0].split(',');

        /** calculate end */
        const shiftArrEnd = lastShift.split('-');
        const lastHourArr = shiftArrEnd[1].split(',');

        const firstHourMin = firstHourArr[currentProject.planification_day];
        let lastHourMax = lastHourArr[subtractPlanificationDay];

        /** if lastHourMax = false, recalculate */
        if (lastHourMax === 'false') {
          while (lastHourMax === 'false') {
            subtractPlanificationDay =
              subtractPlanificationDay - 1 < 0
                ? 6
                : subtractPlanificationDay - 1;
            lastHourMax = lastHourArr[subtractPlanificationDay];
          }
        }

        if (firstHourMin && lastHourMax) {
          setCustomHour({
            ...customHour,
            startHour: firstHourMin,
            endHour: lastHourMax
          });
        }
      }
    }
  }, [calendars]);

  useEffect(() => {
    if (!resizing && tableConfig) {
      let tablesWidth = 0;
      tableConfig.map((el) => {
        if (el.visible) {
          tablesWidth += el.width;
        }
      });

      setTotalTablesWidth(tablesWidth);
    }
  }, [tableConfig]);

  useEffect(() => {
    if (paginatorRef.current) {
      paginatorRef.current.resetAfterColumnIndex(0);
    }
  }, [totalTablesWidth]);

  /** this effect delay the render when using real time feature */
  useEffect(() => {
    const interval = setInterval(() => {
      if (realTimePings.length) {
        handlePopVisibility(false, 'progressMassive');
        realTimePings.splice(0, realTimePings.length);
      }
    }, 10000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (sectorObject.update_ponderators_lookahead) {
      message.info(t('configurating_change_criteria'), 3);
      const alreadyCalculatedParents = {};
      let activityAlreadyCalculated = false;
      if (groupBy.criteria == 'activityId') {
        activities.map((activity) => {
          activity.tasks.map((task) => {
            if (task.parent_id) {
              if (!alreadyCalculatedParents[task.parent]) {
                const parent = getTask(task.parent_id, null, activity);
                calculatePonderators(
                  parent,
                  null,
                  updateAsyncTask,
                  projectState
                );
                alreadyCalculatedParents[task.parent_id] = true;
              }
            } else if (!activityAlreadyCalculated) {
              calculatePonderators(
                activity,
                null,
                updateAsyncTask,
                projectState
              );
              activityAlreadyCalculated = true;
            }
          });
        });
      }
      sectorService.updatePonderatorLookahead(sectorObject.id, false);
    }
  }, [activities]);

  useEffect(() => {
    const currentView = defaultView.current;
    if (currentView.name == 'gantt') {
      updateGanttVisualizationState();
    }
  }, [activities, timelineState]);

  useEffect(() => {
    if (defaultView.current.name == 'gantt') {
      !gantt && setGantt(GanttDhtmlx.getGanttInstance());
      updateGanttVisualizationState();
    }
    if (changeVisualization) {
      updateRender();
    }
  }, [popsVisibility]);

  /** Similar to did mount */
  useEffect(() => {
    const callback = (data) => {
      data.route(history);
    };

    EventEmitter.on('changeMainRoute', callback);
    setContainerHeader('');

    return () => {
      EventEmitter.removeListener('changeMainRoute', callback);
    };
  }, []);

  function setNewDataRange() {
    /** Set default dates as today with 2 weeks forward */
    let start = new Date().toISOString().split('T')[0].split('-').join('/');
    let end = new Date();

    end.setDate(end.getDate() + 30);
    end = end.toISOString().split('T')[0].split('-').join('/');

    const settings = defaultView.current?.activityTreeSettings || {};
    start = settings.start || start;
    end = settings.end || end;

    const newDateRange = {
      start,
      end
    };

    /** Then using set state hook load this vars, to let virtual dom load datepickers with correct dates */
    setDateRange(newDateRange);

    /** Loads activities with their tasks */

    return Promise.resolve(newDateRange);
  }

  const [reactWorker, setReactWorker] = useState(null)
  useWorker(setReactWorker, [gantt])

  useEffect(() => {
    if (!reactWorker || !gantt) return
    gantt.reactWorker = reactWorker

    const handleMessage = (e) => {
      const data = e.data;
      const handlers = {
        'save_single_task_lookahead_finished': () => {
        }
      };

      const handler = handlers[data.cmd];
      if (handler) {
        handler();
      }
    };

    reactWorker.addEventListener('message', handleMessage, false);
    return () => {
      reactWorker.removeEventListener('message', handleMessage, false);
    };

  }, [reactWorker, gantt])

  useEffect(() => {
    async function fetchTableData() {
      await getTableData();
    }
    setReloadDataViwes(true);
    setIsLookaheadFullLoaded(false);
    setLoading(true);

    fetchTableData();
  }, [projectIdSelected]);

  useEffect(() => {
    async function loadAllLookahead() {
      if (tableConfig.length > 1) {
        if (!defaultView.current || !defaultView.current.activityTreeSettings) {
          if (projectState.sectorSelected && projectState.projectSelected) {
            await buildViews();
          }
        }
          
        const newDataRange = await setNewDataRange();
        await handleChangeSectorOrProject();
        await updateTableMetadata(tableConfig, true);
        await getLookahead(newDataRange);
        setGanttVariables();
        setLoading(false);
      }
    }

    function setGanttVariables() {
      !gantt && setGantt(GanttDhtmlx.getGanttInstance());
      if (!window.mountGanttConfig) return;
      if (!gantt) return;
      window.mountGanttConfig(gantt);
      gantt.scrollToTodayAtChart && gantt.scrollToTodayAtChart();
    }
    loadAllLookahead();
  }, [tableUpdated]);

  useEffect(() => {
    if (isReloadDataViews) {
    }
  }, [isReloadDataViews]);

  const changeVisualizationHandle = (view) => {
    setChangeVisualization(true);
    defaultView.current = { ...view };
    setDateRange({
      start: defaultView.current.lookahead_init,
      end: defaultView.current.lookahead_end
    });
    EventEmitter.emit('HIDE_PLANIFICATION');
    // window.location.reload();
  };

  /***********************/
  /** Function section */
  /*********************/

  /** Updates tags state */
  const getTags = async (activitiesReference) => {
    activitiesReference = activitiesReference
      ? activitiesReference
      : activities;
    const tags = await tagService.showByProject(projectIdSelected);
    if (tags && activitiesReference.length) {
      setToSelectTags(tags.tag);
      if (gantt) {
        gantt.toSelectTags = tags.tag;
        const idToAssignLastTag = gantt.toHardAssignTag;
        if (!idToAssignLastTag) return;
        const objectTask = gantt.getTask(idToAssignLastTag);
        let lastId = 0;
        let lastTagObject;
        gantt.toSelectTags.forEach((tag) => {
          if (tag.id > lastId) {
            lastId = tag.id;
            lastTagObject = tag;
          }
        });
        objectTask.tags.push(lastTagObject);
        delete gantt.toHardAssignTag;
        // gantt.changeVisualizationOption()

        /** View local state update and ProPlanner DB update */
        const activityRef = activities.find(
          (ac) => ac.unique_id == objectTask.activityReference.id
        );
        if (activityRef) {
          /** update task data */
          const doesExistAtReference = getTask(
            idToAssignLastTag,
            null,
            activityRef
          );
          if (doesExistAtReference.length) {
            const reference = doesExistAtReference[0];
            updateAsyncTask(reference);
          }
        }

        gantt.refreshData();
      }
    }
  };

  const newFindDefaultView = (userViewId) => ({ view }) => {
    if (view.id == userViewId) return true
  }

  const findView = ({ view }) => {
    return defaultView.current.id == view.id;
  };

  const isFirstView = async (dateInit, dateEnd, views) => {
    const localUser = JSON.parse(localStorage.getItem('user'))
    let viewsDefault = {
      project: projectState.projectSelected,
      sector: projectState.sectorSelected,
      view: {
        name: viewType.find((view) => view.name == 'gantt').name,
        icon: viewType.find((view) => view.name == 'gantt').icon,
        label: t('default_view_name'),
        module: viewType.find((view) => view.name == 'gantt').module,
        filter_query: {},
        order_query: {},
        group_query: '{"criteria": "activityId", "sort": "asc"}',
        columns_json:
          '{"settings":[{"name":"checked","align":"center","label":"","width":30,"groupable":false,"orderable":false,"filterable":false,"data_type":"string","visible":true,"ganttOnly":true,"ignore_as_column":true},{"name":"name","label":"Tasks","data_type":"string","visible":true,"span":3,"offset":0,"align":"left","width":250,"groupable":false,"orderable":true,"orderable_switch":["A → Z","Z → A"],"filterable":true,"ignore_as_column":true,"resize":true,"tree":false,"editable":false,"editor":{"type":"text","map_to":"name"}},{"name":"actions","label":"Actions","data_type":"string","visible":true,"span":3,"offset":0,"align":"left","width":80,"groupable":false,"orderable":false,"orderable_switch":["A → Z","Z → A"],"filterable":false,"ignore_as_column":true,"resize":false,"tree":false,"editable":false},{"name":"roadblocks","label":"Roadblocks","data_type":"string","visible":true,"span":3,"offset":0,"align":"left","width":80,"groupable":false,"orderable":false,"orderable_switch":["A → Z","Z → A"],"filterable":false,"ignore_as_column":false,"resize":true,"tree":false,"editable":false},{"name":"description","label":"Description","data_type":"string","visible":false,"span":3,"offset":0,"align":"left","ignore_as_column":false,"width":200,"groupable":false,"orderable":true,"orderable_switch":["A → Z","Z → A"],"filterable":false,"resize":true,"editable":true,"editor":{"type":"text","map_to":"description"},"hide":true},{"name":"start_date","label":"Start","data_type":"date","visible":true,"span":2,"offset":0,"align":"center","width":97,"groupable":false,"orderable":true,"orderable_switch":["1 → N","N → 1"],"filterable":true,"resize":true,"editor":{"type":"date","map_to":"start_date"}},{"name":"duration","label":"Duration","data_type":"number","visible":true,"span":2,"offset":0,"align":"center","width":60,"groupable":false,"orderable":true,"orderable_switch":["1 → 9","9 → 1"],"filterable":true,"resize":true,"editable":true,"editor":{"type":"number","map_to":"durationDays","max":200}},{"name":"end_date","label":"End","data_type":"date","visible":true,"span":2,"offset":0,"align":"center","width":97,"groupable":false,"orderable":true,"orderable_switch":["1 → N","N → 1"],"filterable":true,"resize":true},{"name":"priority","label":"Priority","data_type":"array/icon","visible":true,"span":1,"offset":0,"align":"center","mode":"single","width":90,"from_values":[{"icon":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABBCAYAAABhNaJ7AAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAFpSURBVHgB7drLbYNAFAXQy4gFS0pwB1nzTeggqSAlJOkk7sCpIO4ACyiEErznl0HywgJHQrIZEO8eyZsnJKMrZuYxDEBERCSWNSxkWfaqlPodlL/CMPzGBqkbNXdY6LrOxUYpCGdPuciyrPeiKJ5hkB6GR9/395jZpAC03eVnTNu2Lzp0a+65Z9VDQD95T5iZ+DmAAUA4BgDhGACEm9oILUK/g/TNUIoH0D3FTxAEh2F91QHggR1oH2ae52UURafruqghoN8vdqMahGMAEI4BQDgGAOEYAIRjABCOAUA4BgDhGACEYwAQjtviUy7SO6p727bv+k5f1/Wn3pr+wMpM3RY/e55X4g56S/qMFeIcAOEYAIRjABDOWAC6B1h8GWyaZnQPxgKoquqgG6ojlnOK43j0/8bOByRJ0qf/lqap6ziO8cPX/zVyxg9IXIJYTVfISRDCMQAIxwAg3K1lsF+iyuuCUqoEEW3RHyDYTI/Y+K3JAAAAAElFTkSuQmCC","color":"lightgrey","value":"Low","label":"Low","weigth":3},{"icon":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABBCAYAAABhNaJ7AAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAFhSURBVHgB7dvBacMwGIbhz6oLOfYa6MGdoMoG7gYZIaYDdIR6keJ2g3aDjKAN6kLBVx9zkqsGXxyXInAsi/zfA85BCSS82EIIBSAiEiw5HdBVkwHqeThq30yx3uMCpX+M5e7aDUYsvtzrHhdIQbjU61MqvdcvzQ6hdLbFlTLusasxM78AsFsotUUwxxuz1dX3gyluDWYU8yNwA1w/YWbi5wAGgHAMAOEYAMJ5LoSWkmRnWYH+s7KMPECXuxVojsmON3qtq8+NKe7a0TtCZLCr0XKekyCEYwAIxwAQjgEgHANAOAaAcAwA4RgAwjEAhGMACOe7K2z6awrdX1HxC2Dth3lcl5jA7e+Xbos7ugCcAyAcA0A4BoBwAQMkLSIULoDq3peN4L5bjc87Bzsf8Hs4QVfNBvbkIHYoCq+LH5Dof0CJiHAShHAMAOEYAMJxS2w8tHIrtkM9GFKHWf+2QkS0lB/UaUak0mWCygAAAABJRU5ErkJggg==","color":"darkturquoise","value":"Normal","label":"Normal","weigth":2},{"icon":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABBCAYAAABhNaJ7AAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAF3SURBVHgB7dpfSgJRFMfx37mOYGFhO3AHLSGXUCsIMR96qnaSz/2zFeQOcimzBCmQgXHmdAsCmUEYUO8Mnt/n8SAoX7jXy50BiIiIzJLi4Ou5ddkS+VifaS4P3XH6iAPkShNBrzhSaA8HysG4qMqHnNPr5Wt0gYCcyKwzTCfYs0oB/Lroq6KPgDLVwfKlLcej/e49jV4CCpxjz8zvAQwA4xgAxjEAjKt4EKpLPvAn0E/sQK763h1l0+K84QF2dwIVyOD7KYpPxqv5+tzUEhDVfnHGTRDGMQCMYwAYxwAwjgFgHAPAOAaAcQwA4xgAxjEAjKt0K+xvZietNNrqOX3WXt2L4A4NUzXA4ug2ibEFfyW9EEHjcA+AcQwA4xgAxgUL4J/OLlCz3KH0G4IFSKN06g8UM9TEn2XmpzdZ6fuDvR9wNvytn13pG3pJ0gn+8vWmg1zwFyTkL0RS+3L4x00QxjEAjGMAGFf+G/SXHxCN10fiEIOIDtEPBo9Yl6szW4UAAAAASUVORK5CYII=","color":"orange","value":"High","label":"High","weigth":1},{"icon":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAFYSURBVHgB7dpBTsJQEMbx/6u6xgNgUm/gEfAG3EC9gTeQmyg34QjewCZA3LIWYRyCMQS7aFJbXpzvlzSQ1y6aL32TycuAiESWjhfeodzA6HBtDbNrqIhgAffLlOzwmsOEf6oguPMmD6WiGLxttyU96mvL/aoBuy2QUnrm9KoPs9uug8h5C5T+eT7SsaxrgL/cgI6FL4IKgOAUAMGpEyRj3pBdzs1GtOTd3moIr3X3sg7AYFykNOYPLD2A785ydbgeaQvcXHigx4sqggSnAAhOARCcAiA4BUBwCoDgFADBKQCCUwAEpwAIrumpcGVmFS34EXfpPyWZaRTA1mx61XJOyM/3J37E/URmVAMITgEQnAIgOAVAf2ac2LrmHXqbD/BGarYwe/C/d/RsNyCxgWnd1GmvAxJDeGF/ZUM1gOAUAMEpAILTkdjxwpk3LJt9w/LjM4MuTkSkC19WxUeIQjWrTQAAAABJRU5ErkJggg==","color":"red","value":"Urgent","label":"Urgent","weigth":0}],"groupable":true,"groupable_switch":["1 → N","N → 1"],"orderable":true,"orderable_switch":["1 → N","N → 1"],"filterable":true,"resize":true,"hide":true},{"name":"progress","label":"Progress","align":"center","resize":true,"width":"70","editor":{"type":"number","map_to":"progress","min":0,"max":100},"hide":false,"data_type":"number","groupable":false,"orderable":true,"orderable_switch":["1 → 9","9 → 1"],"filterable":true},{"name":"ponderator","label":"Weight","data_type":"number","visible":false,"span":2,"offset":0,"align":"center","width":110,"groupable":false,"orderable":true,"orderable_switch":["1 → 9","9 → 1"],"filterable":false,"resize":true,"hide":true},{"name":"status","label":"Status","ignore_as_column":false,"mixed":false,"mixed_from":["Overdue","Advancement"],"data_type":"array/icon","visible":false,"span":1,"offset":0,"align":"center","mode":"single","width":95,"from_values":[{"icon":"fas fa-clock","customIcon":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAQkSURBVHgB7ZtfUtswEMY/yXkvmWnfSjEnKNwgnAA4AXAC/vQAwAGAcAKSG8AJmhs0N6gYeCudpO+x1JVxZjKJZFuO4jjBvzcixfF+Wq1WKwHU1NTUfGAYSiI8G2xEQdRiioUA36KPNqa6DAH5LKXsN9Doi3ZziBJYqABfz/60OG/s048c0J+hy3fpzfpKoS/lqPva/tLDgvAugB5pyXFKDz7D7CgXRSiGNo/wRJ4h4BFvAizI8BkUcMUlur6E8CLA5o+3A66CByzQ8CmERHT9cvu5gzmZS4Bk1O/oIcdYAuQNHfKG83kCZmEByPhQcfyEa3Dzj2ASe0WnBEcByPgdMv4Xlm+8Jh4I/U4ogLMHJMbrkS9rvudlmHhC3+VLTgJUyO1taBF2XaZDbgF0wKuQ26chEhFyBcbcMUBHe1TfeE2YvGsucnnA5sXbMUe8zq8MkuHw5ab5mNUvU4CFzHuFHqW2YuIlWvDvXToebGdNhQay4DiC55eTLOpOZnHfzv92GOMh/EJJmtRp+VVap9QYEI9+xgOqDAM/1cE7rU+qAKTgAVabsRdYSRVAK4gVJ8sGqwAhFTOwGsteFhtfzwYtW6NVAMkbR1gTOLNPZasAjKHQ5qKK0Aqzb2szChBHTrU+AhChbTWweMBonYx/J4iTrRksAvC1E0AqGZo+NwpAebSx80qjzDbZgmDVih3zw/gn08eFSmLzErCglFOfPJQrAEMvLlvl2KaWRfZu0A+CtrzXZHgHFcMmgC8XHZLh95Bo2/bl4fnglGoD+1g0Sv4zfWwUgKv4LG5eHtn7oYUwNeqD0yBo3KmyEq6JAswkRgGiQAkSoegP9VhE7t5u9kzNcY0hwAMtSy0U/Y0CSMmN5XKjAEEU9JR7eBwm87xtakyO0S6VPjwt0fAxZKhRAKujb10MfsNtO2yswZV1apwKQ//5prlrarKOs1LyCW7MVF/0qbE+S2DvZbWlJVf6ooWtzeoBNHKtpBrsQnwyM8IopAB3Gc/zChBR7vFqiUmpsZ6mwQDuIydQrUqSeL5tbtsaM2qC8h7uhKgQcR6SQnqsl1xH9Mrk7YWQSE27UwXQEb2gF1QChTgfEWl9slf71fUCwSU6WZ0yBYi9QOIEKwbLMfqaXPkePeiR8oIuVgR9eUrc5tt55k54ueI6yRGoPtr1z/N2zi1AMhX2UO14ML4xlvsdnbY8ek5VWAQ9QIeu1+Wc93z6FlYigkB1KHRDTFNflERBkumwu8zVgXZ5XddrcdN4uSwdXgyOaem5RHneMKTD2xMf1WWf1+VD8qexEIsis8jqijcBxsRCALoQom9mhPCDd8PHeBdgEl1UkUweM86/FzhuF7oqRQnYo63A6oOFCjBJcj6/Q9NkJz6pnT6ro7o9Z1zQKAv6q1fWP03V1NTUfGj+A6hroAzhrW21AAAAAElFTkSuQmCC","color":"yellow","value":"Advancement","label":"Ahead","weigth":4},{"icon":"fas fa-clock","customIcon":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAOSSURBVHgB7ZvRUdtAEIb/Oxgmb/ErEwJyBSEVBCoAKohTAUkFgQpCKgjuACoIHYQOUBIyeQx5Soaxb7NrywSMTtLJJ1sn65thjCWPpf1vb++0uwZaWlpalhiFOXEFdFaAHQ1E0HqLL9y5f56AGxjzlV8vB/zXlfdzoFIBvrPBSus9RbQPMdyNSyh1aYzpPwcuUBHeBZCRfqL1oSF6i6lRnoF4RamTP8acs2fE8Ig3ASoy/BFaqaO/7BW+hPAiwDdgn0foEyo0fIqYiI43gFPMyEwCyKivaf0BRD0sAqVOb415N0vALC3ATw5qRqnPcA9uvolviXbLTgmNElwD22z8FyzeeCFa44GQe0IJnD1ALqTGIz+v+V6UG44LuxuyfDrgJECN3N7GDU+Hly7TobAAo4BXH7fPIk5EKBQYC8eAUbSvv/FClNxrIQp5AM/7nhqv88EwJDrYBM7yPpcrQBXzni96wQEr/n9A7cC/d0k86OZNhVXkofVr3uhE8Ahvl/v3d3HXRKfsYRH80mHjZFt+lPWhzBgwGn2iIwQKPzccXuUs15kCDHmPj7CZeIGVTAHYLQ8RODrHBqsAksxAGMteHp3EllSsAmgJfs3BOpXtU4Co1MNFHeFpsGc9l3YwiZyNEYCJbKtBqgCrzTJ+xIolDqQKoBoogLYE9FQBqBnR/wHkIoCqX7JjZtjQp5bjy00rAJac1MdhKVRWWTTkeuGra2Pu3vNGZYtQLXy132nHUwVQnutvj+BCCj9o9e7eonpsNqVOAVO1AAuALOnyVAGGFZajF8XARYAkjxajOVgbLqyrAKfCztEUiKzVoqxlMDelHAoc0/q2c5mr3Q+lfiH8bXH8jNPjtpOZGyGeBh8ROCrHhkwPSOqB/BKuFyTFkdh2PtMDJHKG7AV878d5leLcZwFeP08wp549z8SDAj1EuQKIF3Ch8Q0CgwqMvlDoaVCqrKRUH6HAtcaiHWRtgwQKIl+oiXZR73gw6RgrfI9OCZH1cYNiXUWQJqkD13Y554yQdGElIsSoD6U6xIS2URIlWU+CDSu/sNVBru3aFjeNl9Rf0kT1HvPzhtHeZNPDE6u33KdMCd559fRYiKoYbc1ld9r1FIi9J39FCGmtSbpLIvjBu+ETqsx+j38yw17B/75gQdwKrkQxJzIkK3UW1E9mbFyNG5a2pfIshcrpWp3k7SV1LRlpScp2673hamlpaWkG/wCz3EndGpIA2QAAAABJRU5ErkJggg==","color":"yellow","value":"Overdue","label":"Overdue","weigth":3},{"icon":"fas fa-clock","customIcon":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAASZSURBVHgB7Zt/Uhs3FMefpLVbEzN1TpDNDeAEsU+Q9ASFcchM/yKcwPgESf5NJ7VzgjYnsHsCuEHdE7BtKc0sK72+h7sz0Gh/slrvUn9mGMNKjK2vnqT3QwbYsmXLlv8xAmriYgYDpdVQIvpSyicIYnC73Rj8TYAJEOR55EXnjw8hgBpwKsCfP3hDJeE5Ar6gt/KL/C99snOBsNQGPu0eRUtwROUC8Ex/Dd6xNvha/GeWy4MrBJheh3r5+HtYQYVUJoCbgX+JlHD6+XP0sSohKhHgatY5Nsacuhz4XdYW0R/rOdyTewnAs/4Vej8hwhA2As7DUE/vYw2lBaDB+12jFoU3t8rBFYkwKitCKQEu3sNeR6lFfSafSYBajPqvrs+hIIUFaODgY0qJUEgANvuOUWcNHHxMEIbRfpHlIPN2jNd8gwfPDLpdteDNOe8/5BaABj/Z/IaXB+HzyZS7d55Olx/UAc38DCoD2c8Pbn8Iig18qBD6vCc74+u32f0ycHHcsY+/8zIaxX//QQKrSgW+IQhl9DQrqMpcAl3wvnNu+ugk8ht0I+91VqdUAXj2wcApOEagcBP6SjjO2hBTBaAjbwjtJtMKUgWgDWICbYesIL05AU5muFr7KKFOX2KwHoudZAsQ8AJcgXhHAIGR0/SXSBlLogBCwjOoCdUBxwLg86Q2qwC8c9JZvQcPBuEnnQZWAbzIe0CDX8MZadtzqwDkRj44ASRK3/rc9pDS2E2O+Moh0Lc9tltAQmdX9A6rTXXbEEJ8Y3ueOxyuktrKUTmoWQAMjIFpT+p9aAge1AbOd6Q+EeN6an55sQpAyYmgKjOlmsGSfqa7R3ppa7+pHyqYUB+ncPHV9twqAIWnK85a3A+kSi+c9F/aqzfsmFCi5Q39euB68Awd7VbLswpghFmp0lsVr3Pxru/pt8KSjbldQ4QaE6x0tFvT5VYBtNJLZUptD4EM9f6jhLQ0m7s0ODMAvqj5LOA7B7bn1lNgnUfDFRRnoLtfupxcTLn60VtQZXczpTQBiRcuEo9Bg+ITlHovmMSBB79ezbw3XeWdba6ASlNp4JektmQ/AOFnKIXwOQ3FJXNKqf1Kb56ZmHQNpowldSH+9cG7oJdWxwWClvLOWD9Nak/1BMlrewcthzbcaVp7qgC0c3JlpVGeW1FUaHfAYlIF4J2z1VbAcUdGpTgzGGqrFfDal1E0z+qXKQBbARozhZbBa7+X455AbnfskhwZscGzvBg4fzTWh3l65s4HXIvoW1HOO6yVG9MPdW6LLeSQ/03FUmO8M2isb4A3sUjPxRUZhnN3fBEJGrkpUvit9ahX8LpcqZDs8n1nTyikwKYplrAefP8VuL8mF8PLAY1aVH21pSi85kVYfOZjSidFeTkIqUeI+BE2BKfbOMHa28RV2dvwJSpSclKfNZDJGzntH2VfgsqisrQML4ko8g4o6eHwUkWcbous6bYyVJ6XYiG0UcNqLaL6gcc4/8rMv5cTntFrwYIrrpCyUpzMaNVXZpJASo9dUtldgNlDkAMpxZM77Yi/U+5qZYRY7VJSVhy2OwzfsmXLllbwDzNn3KA0hSsKAAAAAElFTkSuQmCC","color":"yellow","value":"Doing","label":"Developing","weigth":2},{"icon":"far fa-check-circle","customIcon":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAARSSURBVHgB7ZtLctpAEIb/EWQdcoLgEwQ/socTGPJYG5/AzgmAE8Q+AWadB/YJzD62ww1MThCyDtKkWwgXoWYkjdAT66tymZKENP2ru2emZwBKSkpKnjECKdEYo1ax0ZQCdcvCa3pwbf28BOaOg1+Wg+miium0gzlSIFEBjr6giSqOybg2PagOM6b0valYYHT3ERMkROwC8JuuAmf08Rwbbzkq1MgZ/bv4C9yQZ8wQI7EJkIThGvoLYBSXELEIcPiVXLyCIZI1/An2CNvB4OE9rrAlWwngJjbgM92kiwygHHFlA5+2SZiRBSDj6y+AW2me3GKFvYFyQytqSFiIABnfoHj/mbXxDLeBX8RbahMiYOwBnvG3SCneDZiTMa0fHUxNvmQkQF7c3oc59RD7JuEQWgBOeC9y4vZ+eDlhP2xiDJ0DONvn3XiG28htDXt9KA84+IYujd+HKBDSRuf+A66DrgsUIKG4n3jDWxcHaIr4vYvzwV5QKFQRQNXCiXTibRzN+kbro7jD7/RZxC5Areq4w/K+30W+OYDfPr2ePoqKhTNO3v6X+J100EaxWXmBFl8BKpY7uys2ATZoBTgaU/WmAN1eCGpuYUaDVgAy/gQ7gqzoQ1krAHVLkSYXecQSONaeUx30MufOCMChrOsNlAJUd8j4FTQ8bqqO60Jg5wQQmsGcUgApdyL7/4cUBgIg5WIHNY6LGIkuhFAifKk8jhzw0MEFFzLI80ZImVwIwHAV5/4dujyDS1OITATg2sLhGEN3srXBSgjqujoS8a4CKduiOZ74wiSvJXCdgYbcPdX5+w6u6W+PagWncQjhSPxRHVcKIETyyjPeXKNPJe1HrjqprqH8cMVC0McBtngxQqptUneDdjoCPD0P7pL50E+Iu467Jhg9UTrqcrmyJOYtdP5GdlwvlkteM9VJFsp0pkr3e6Uqjyk9gC9MIwH50KYX8KhKlOwhEabp2g0X+pqgxA35R6YFEU6U1MAuJUoeJ1zyMRrT96TZbTjEtKtF+umwCC4pp8g59xhR1yZ4l4n2nM/3uCrEeSBva4BGcCh7vYiSoIHQJQqOCLDBVwCKuwsgnd1aSUE2+IayrwBe5iyuFzgYBK0UB84FiuoFHPsLK3gPUaAA3pjgFAWD2jwIs08g1GyQJyZZzNWjwpuneA4R5trQ02Fb4Dzj0WEouI28cyzs9aEF4FCgG7eQ43zgGd8y2TZnVBDhmBI5FYE3W5PxHdPtcsYVId6FxSLkKRw84/nNG+0QY4y3ya3gWRqNzW8T2NlhxJrbzxCByDVBfqCdUSV3BT/bNtwWt0lkD1jnYIwu3aiXljfIZQ465e4ZWxKLAAyHRHW5abqHhJDL3aCXPDqN6xclsQmwwhOiTY09i8sjkjB8RewCrOPuMpEUHgJvYLjg6vYyVJXiwgwVRCdIiEQFWMcrtDaozt+gEnV9c62O6/a0RjgTy6w+SetHUyUlJSXPmn8bP3YlQBkB9wAAAABJRU5ErkJggg==","color":"green","value":"Done","label":"Finished","weigth":1},{"icon":"fas fa-minus-circle","customIcon":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAOqSURBVHgB7ZtfUuJAEMYbRF+XGxhPsHqCxROozxQIJ8A9gXgC9QQQKN71BHCD5QjsCZZ95t9+vTVYlGYmM2EmZEJ+VRaQBEl/6e6Z9HSICgoKCo6YEqVEr9erViqV2mazCcrl8vl6va7u7se2Obb9Xq1WU3ycttvtOaWAUwFgdO309PQGb2/ZcJPvlkql/0IsFosQYkzIEdYFEFe6g7cP+KuSBSDGDAK+LJfLd4gxI4tYE8CF4RK6ECK0JYQVAYbD4S1eeuTW8A/YI5AvnprNZp/2ZC8B+Kojxp/hni06ABCijxzxc5+EmVgAGB/A+LFpcrMNewNEuE4aEmVKAIy/RLz/OrTxDJ8DX4jRaHRJCTD2AGH8mFKKdwPmmEtc1+v1qcmXjATIitsrmGOEuDIJB20BRMLLhNurEDnhSjcxaucAke0DyjgiJzzrHq/lAYPBoAVle+QXd41G4y3uoFgBHMX9BP9vtvO5BoEDsgvng4u4UKhQDGdnZ/eYdQVkERgf7s7iwjDsOxCgilGBp+Vd1UHKHMBXH8Z3yVMgQIeTt/IY1c6Tk5Nb8putF0hRCsAKkufE2SAVAHd4NR+GPQ2qXJiR7ZQKgKR0TzkBU3dpKEsFwNVPdHORRXAxb2T7IgUQmTM3AnAoy0aDSAHgMrkxfgtXpKO2RwqQJ/ffIkvoZZODfUY205QlwawVO/YGF/Vb1PZEJbE8UQhAR47sdtjpwiTm5z9QZNn9fI4YJZcgCf6N2l6RHDwjh/BCCn6jtfOZXPOpAPNBZAi4FuAQiGX3L0QKgFLShPKHvgBcR8uZF0gbLqSjAFzmnXKCaLaIRCoAMnNsSdkXuMtEtk9ZFsdQ9QfqeT0t5uyPCvSFbL9yIgTjX8l/lDYoBcBo8AIFU+nWcgVymTKUlQKI0cBbL+A2mriV4th7AV+9gGMfAvTjjosVQHhBm/zjSadPQOtuUKyyhuQJ3Dyl20GmfTuMUHiQ3VBkCT5H7hzTPV5bAA4FZNTrLOcDNp7P0aRtzqggwjGVVRH4nHBud6btcsYVIfzAVIgwo4wgjOcrb9QhxuzVKInl87GDxgYjdtx+RglIXBMU4XBFhx0dQj6HfRqnrTRLcxMVXh7T8gZ2eZ6b6DRBxWGzXT7A+lsLbx/JEcLwV56d2nqixMUDE4ForenY8ggXhm9x+sgMd5ngpYW/72S43C6eEuGq1BtcfUKOSPuhqUteeWbP+LxWx3V7zuhsOBdl03poqqCgoOCo+QfjadOkAqG3NQAAAABJRU5ErkJggg==","color":"grey","value":"Waiting","label":"Uninitiated","weigth":0}],"groupable":true,"groupable_switch":["1 → N","N → 1"],"orderable":true,"orderable_switch":["1 → N","N → 1"],"filterable":true,"resize":true,"hide":true},{"name":"lean_status","label":"Lean Status","data_type":"array/string","visible":true,"span":2,"offset":0,"align":"center","mode":"single","width":125,"from_values":[{"color":"#E50101","value":"Restricted","label":"Restricted","description":"LEAN debit status means...","weigth":4},{"color":"#121212","value":"Debit","label":"Should","description":"LEAN debit status means...","weigth":3},{"color":"#34AF00","value":"Can","label":"Can","description":"LEAN can status means...","weigth":2},{"color":"#309FE9","value":"Will","label":"Weekly plan","description":"LEAN debit status means...","weigth":1},{"color":"#F59D04","value":"Committed","label":"Committed","description":"LEAN debit status means...","weigth":0}],"groupable":true,"groupable_switch":["1 → N","N → 1"],"orderable":true,"orderable_switch":["1 → N","N → 1"],"filterable":true,"resize":true,"hide":true},{"name":"cost","label":"Cost Budgeted","data_type":"number","visible":false,"span":2,"offset":0,"align":"center","width":125,"editor":{"type":"number","map_to":"cost","max":1000000},"groupable":false,"orderable":true,"orderable_switch":["1 → 9","9 → 1"],"filterable":false,"resize":true,"hide":true},{"name":"expected","label":"Expected Progress","data_type":"number","visible":false,"span":2,"offset":0,"align":"center","width":125,"groupable":false,"orderable":true,"orderable_switch":["1 → 9","9 → 1"],"filterable":false,"resize":true,"hide":true},{"name":"expected_cost","label":"Cost Expected","data_type":"number","visible":false,"span":2,"calculated":true,"offset":0,"align":"center","width":125,"groupable":false,"orderable":true,"orderable_switch":["1 → 9","9 → 1"],"filterable":false,"resize":true,"hide":true},{"name":"responsables","label":"Responsible","data_type":"array/images","visible":true,"span":2,"offset":0,"align":"center","mode":"multiple","from_values":"toSelectResponsables","el_to_extract_from":"email","el_to_label_from":["name","lastname"],"img_from":"image","width":86,"groupable":true,"groupable_switch":["A → Z","Z → A"],"orderable":true,"orderable_switch":["A → Z","Z → A"],"filterable":true,"resize":true},{"name":"subcontractId","label":"Company","data_type":"array/string","visible":true,"span":2,"offset":0,"align":"center","mode":"single","width":98,"groupable":true,"from_values":[{"value":846,"label":"2prueba","weigth":1},{"value":836,"label":"aire acond","weigth":2},{"value":691,"label":"carlitos","weigth":3},{"value":689,"label":"Casa","weigth":4},{"value":1194,"label":"caso","weigth":5},{"value":838,"label":"datos equipamiento","weigth":6},{"value":835,"label":"electrica","weigth":7},{"value":1190,"label":"fra","weigth":8},{"value":837,"label":"incendio","weigth":9},{"value":1189,"label":"jose","weigth":10},{"value":1173,"label":"o","weigth":11},{"value":845,"label":"Pepitovgkkkk","weigth":12},{"value":821,"label":"Prueba","weigth":13},{"value":1172,"label":"r","weigth":14},{"value":1191,"label":"ro","weigth":15},{"value":12003,"label":"rtrtrtrt","weigth":16},{"value":1192,"label":"tr","weigth":17},{"value":1193,"label":"ttt","weigth":18}],"groupable_switch":["1 → N","N → 1"],"orderable":true,"orderable_switch":["1 → N","N → 1"],"filterable":true,"avoid_translate":true,"resize":true},{"name":"tags","label":"Tags","data_type":"array/images","visible":true,"span":2,"offset":0,"align":"center","mode":"multiple","from_values":"toSelectTags","el_to_extract_from":"id","el_to_label_from":["name","description"],"img_from":"image","width":125,"groupable":false,"groupable_switch":["A → Z","Z → A"],"orderable":false,"orderable_switch":["A → Z","Z → A"],"filterable":true,"resize":true,"hide":true},{"name":"taskRoute","label":"WBS","data_type":"string","visible":false,"span":2,"offset":0,"align":"center","width":125,"groupable":false,"orderable":true,"orderable_switch":["A → Z","Z → A"],"filterable":false,"resize":true,"hide":true},{"name":"plan_endowment","label":"Crew Size","data_type":"number","visible":false,"span":2,"offset":0,"align":"center","width":75,"groupable":false,"orderable":true,"orderable_switch":["1 → 9","9 → 1"],"ignoreGantt":false,"editor":{"type":"number","map_to":"plan_endowment","max":1000000},"resize":true,"ganttNewColumns":true,"filterable":false},{"name":"real_endowment","label":"Crew Size Actual","data_type":"number","visible":false,"span":2,"offset":0,"align":"center","width":125,"editor":{"type":"number","map_to":"real_endowment","max":1000000},"groupable":false,"orderable":true,"orderable_switch":["1 → 9","9 → 1"],"resize":true,"ganttNewColumns":true,"filterable":false,"hide":true},{"name":"commitment_percentaje","label":"Weekly Commitment","data_type":"number","visible":true,"span":2,"offset":0,"align":"center","width":125,"groupable":false,"orderable":true,"orderable_switch":["1 → 9","9 → 1"],"filterable":false,"editor":{"type":"number","map_to":"commitment_percentaje"},"hide":true},{"name":"unique_correlative_id","label":"UID","align":"center","width":"*","resize":false,"hide":true,"data_type":"number","groupable":false,"orderable":false,"orderable_switch":["1 → 9","9 → 1"],"filterable":false}],"columnsActive":["checked","name","actions","roadblocks","actions","roadblocks","start_date","duration","end_date","progress","responsables","subcontractId","plan_endowment"]}',
        lookahead_init: dateInit,
        lookahead_end: dateEnd,
        lookahead_range: '1 week',
        gantt_date_init: dateInit,
        gantt_date_end: dateEnd,
        default: true,
        barColor: 'subcontract',
      }
    };
    const newView = await viewService.create({
      projectId: projectState.projectSelected,
      sectorId: projectState.sectorSelected,
      order: 1,
      isConnectActivityTreePane: true,
      ...viewsDefault.view
    });

    viewsDefault = {
      sector: projectState.sectorSelected,
      order: newView.order,
      view: {
        ...newView.view
      }
    };

    if (newView) {
      dispatch(lookaheadActions.setLookaheadViewsConfig([viewsDefault]));
      listView.current = [viewsDefault, ...views];
      defaultView.current = viewsDefault.view;

      EventEmitter.emit('HIDE_PLANIFICATION');

      if (newView.isPartialSavingActivities) {
        notificationSystemV2({
          key: 'partially-saved-activities',
          type: 'warning',
          message: t(
            'lookahead_visualizationOpt.time_frame_exceed_limit_default_message'
          )
        });

        trackingEvent(
          'timeframe_filter_data_limit_reached',
          {
            ...getBasicAmplitudEventProperties(),
            viewId: newView.view.id,
            source: 'first_view',
            timeframe_selected: '4',
            total_items_requested: newView.totalActivities,
            max_items_loaded: newView.maxItems
          },
          AMPLITUDE_SERVICE
        );
      }

      if (newView.totalActivities === 0) {
        notificationSystemV2({
          key: 'time-frame-empty-activities',
          type: 'warning',
          message: t(
            'lookahead_visualizationOpt.time_frame_empty_activities_message'
          )
        });
      }
    }
    return newView
  };

  const setTimelineAsDefault = (views, idx = 0) => {
    if (!views.length) return false;

    if (idx >= views.length) {
      return false;
    }

    if (views[idx].view.name == 'gantt') {
      views[idx].view.default = true;
      return views;
    }

    return setTimelineAsDefault(views, idx + 1);
  };

  const findDefaulViewSetDefaultView = (views, userViewToFind = null) => {
    const fechedViews = JSON.stringify(views);
    const statedViews = JSON.stringify(lookaheadState.configViews);

    if (fechedViews !== statedViews) {
      views.sort((a, b) => {
        return a.order - b.order;
      });
      dispatch(lookaheadActions.setLookaheadViewsConfig(views));
    }

    if (!views.find(newFindDefaultView(userViewToFind))) {
      const defaultViewList = setTimelineAsDefault(views);
      if (!defaultViewList) views[0].view.default = true;
      else views = defaultViewList;
    }

    listView.current = views;
    defaultView.current = views.find(newFindDefaultView(userViewToFind)).view;
    const names = [];
    if (tableUpdated) {
      defaultView.current.columns_json.settings.map((col) => {
        if (col.visible) {
          names.push({ label: col.label, value: col.name });
        }
      });
    }
    dispatch(lookaheadActions.setActivatedColumns(names));
    window.defaultView = defaultView
    window.listView = listView
  };

  const buildViews = async () => {
    if (isBuildingViews.current) {
      return null;
    }
    
    isBuildingViews.current = true;
    window.loader.show()
    try {
      const { sectorSelected: scheduleId, projectSelected: projectId } = projectState;
      const views = await viewService.showByProject({ scheduleId, projectId });
      window.views = views;
      let dateInit = new Date();
      let dateEnd = new Date();
      dateEnd.setDate(dateInit.getDate() + 30);
      dateInit = dateInit.toISOString().split('T')[0].split('-').join('/');
      dateEnd = dateEnd.toISOString().split('T')[0].split('-').join('/');
      const localUser = JSON.parse(localStorage.getItem('user'))
      const currentSector = projectState.sectorSelected
      const updatedUser = await userService.show(localUser.id)

      const allUserDefaultViews = updatedUser?.user?.defaultLookaheadView
      const userSectorDefaultView = allUserDefaultViews && allUserDefaultViews[currentSector]
      const existDefualtView = views.find(view => view.view.id == userSectorDefaultView)

      if ((!userSectorDefaultView || !existDefualtView) && !defaultViewCreated) {
        setDefaultViewCreated(true);
        const newView = await isFirstView(dateInit, dateEnd, views);
        const newDefaultUserSectorView = allUserDefaultViews ? {
          ...allUserDefaultViews,
          [currentSector]: newView.view.id
        } : {
          [currentSector]: newView.view.id
        }
        const updateUserDefaultView = {
          ...updatedUser.user,
          defaultLookaheadView: newDefaultUserSectorView,
          updateDefaultLookaheadview: true
        }
        await userService.update(updateUserDefaultView)
        return newView.view;
      }

      findDefaulViewSetDefaultView(views, userSectorDefaultView);
      return defaultView.current;
    } catch (error) {
      Sentry.withScope((scope) => {
        scope.setContext('buildViews', {
          message: error.message
        });
        Sentry.captureException(error);
      });
      return null;
    } finally {
      isBuildingViews.current = false;
    }
  };

  const buildIndicators = () => {
    const tasks = getFlattenActivities(cloneDeep(currentActivities.current));

    const processTasks = tasks.reduce((a1, c1) => {
      a1[c1.lean_status] = a1[c1.lean_status] ? (a1[c1.lean_status] += 1) : 1;
      return a1;
    }, []);

    processTasks.total = tasks.length;
    setIndicators(processTasks);
  };

  /**
   * This function updates the subcontracts when a new one is added in the gantt view
   * @param {*} subContractsOrdered updated subcontract list
   * @param {*} gantt Gantt object ref
   */
  const updateSubContractGanttView = (subContractsOrdered, gantt) => {
    if (gantt) {
      gantt.subContracts = subContractsOrdered;
      if (gantt.toHardAssignSubcontract) {
        const idToAssignLastSubcontract = gantt.toHardAssignSubcontract;
        const objectTask = gantt.getTask(idToAssignLastSubcontract);
        let lastId = 0;
        gantt.subContracts.forEach((s) => {
          if (s.id > lastId) lastId = s.id;
        });
        objectTask.subcontractId = lastId;

        /** get activities */
        const activityRef = activities.find(
          (ac) => ac.unique_id == objectTask.activityReference.id
        );
        if (activityRef) {
          /** update task data */
          const doesExistAtReference = getTask(
            idToAssignLastSubcontract,
            null,
            activityRef
          );
          if (doesExistAtReference.length) {
            const reference = doesExistAtReference[0];
            reference.subcontractId = lastId;
            updateAsyncTask(reference);
          }
        }

        delete gantt.toHardAssignSubcontract;
      }
      gantt.render();
    }
  };

  const updateDefaultViewFilters = (filterType, value) => {
    defaultView.current[filterType] = value;
  };

  /**
   * This function handles with resize of cols inside the table from dragging resize  from header titles
   * @param {*} width Updated width catched from the event
   * @param {*} colMetadata Single column metadata that were resized
   */
  const onDivResizeHandler = (width, colMetadata) => {
    if (colMetadata.doubleClicked) {
      colMetadata.width = width;
      colMetadata.doubleClicked = false;

      const findIdx = listView.current.findIndex(findView);

      defaultView.current.columns_json.settings.forEach((column) => {
        if (column.name === colMetadata.name) {
          column.width = width;
        }
      });

      listView.current[findIdx].view.columns_json.settings.forEach((column) => {
        if (column.name === colMetadata.name) {
          column.width = width;
        }
      });

      listView.current[findIdx].project = projectState.projectSelected;
      listView.current[findIdx].sector = projectState.sectorSelected;

      updateTableMetadata(
        defaultView.current.columns_json.settings,
        false,
        true
      );
    }
  };

  /**
   * This function handles the click, and the unclick from user when the resize is catched
   * @param {*} col Single column metadata that is going to be resized
   * @param {*} val Boolean, true for start resizing, false for end resizing
   */
  const onDivResizeDoubleClicked = (col, val) => {
    col.doubleClicked = val;
  };

  const loadCalendars = (calendars) => {
    /** This method load calendars to Gantt API and also creates a custom version to use custom calculate duration */
    const customVersionCalendars = ganttAPI.loadCalendars(calendars, gantt);
    setLoading(false);
  };

  const loadStoredGroupQuery = (currentActivities = activities) => {
    if (defaultView.current.name && defaultView.current.group_query !== '') {
      modifyGroupBy(
        JSON.parse(defaultView.current.group_query),
        currentActivities
      );
    }
  };

  const inDepthTasks = (singleParent, task, activity, colName) => {
    task.activityObject = activity;
    if (task[colName] == singleParent.value) {
      task.parentIdForGantt = singleParent.id;
      singleParent.tasks.push(task);
    }

    for (const children of task.children) {
      inDepthTasks(singleParent, children, activity, colName);
    }
  };

  const modifyGroupBy = async (newGroupBy, data = activities) => {
    let newDataActivity = data;

    if (newGroupBy.criteria == 'activityId') {
      if (defaultView.current.name == 'gantt' && window.ganttVisualization) {
        massiveUnselected(window.ganttVisualization, setMassiveSelection);
      }
      if (!isTree.value) {
        if (defaultView.current.name == 'gantt') {
          data = await getLookahead(false);
          isTree.value = true;
        } else {
          const newData = lastLevelActivitiesCard.activities;
          const dataToLoad = newData?.sort(
            firstBy('id', { direction: 'asc', ignoreCase: true })
          );
          defaultView.current.group_query = JSON.stringify(newGroupBy);
          setGroupBy({ ...newGroupBy });
          setIsTree({ ...isTree });
          dataToLoad.sort(
            firstBy('correlative_id', {
              direction: newGroupBy.sort,
              ignoreCase: true
            })
          );
          if (newGroupBy.sort.toLowerCase() == 'asc') {
            dataToLoad.sort(
              (a, b) => parseInt(a.correlative_id) - parseInt(b.correlative_id)
            );
          } else {
            dataToLoad.sort(
              (a, b) => parseInt(b.correlative_id) - parseInt(a.correlative_id)
            );
          }
          updateRender(dataToLoad);
          isTree.value = true;
          return false;
        }
      }
      data.sort(
        firstBy('correlative_id', {
          direction: newGroupBy.sort,
          ignoreCase: true
        })
      );
      if (newGroupBy.sort.toLowerCase() == 'asc') {
        data.sort(
          (a, b) => parseInt(a.correlative_id) - parseInt(b.correlative_id)
        );
      } else {
        data.sort(
          (a, b) => parseInt(b.correlative_id) - parseInt(a.correlative_id)
        );
      }
      isTree.value = true;
    } else {
      let col = tableConfig.filter((el) => el.name == newGroupBy.criteria);
      if (col.length != 0) {
        col = col[0];
        if (!newDataActivity.length) {
          newDataActivity = await getLookahead(false);
        }
        if (
          newGroupBy.criteria == groupBy.criteria &&
          newGroupBy.sort != groupBy.sort
        ) {
          newDataActivity.sort(
            firstBy('value', { direction: newGroupBy.sort, ignoreCase: true })
          );
        } else {
          if (isTree.value || newGroupBy.criteria != groupBy.criteria) {
            isTree.value = false;
          }
          if (
            defaultView.current.name == 'gantt' &&
            window.ganttVisualization
          ) {
            massiveUnselected(window.ganttVisualization, setMassiveSelection);
          }
          let newData = [];
          if (col.from_values == 'toSelectResponsables') {
            let maxN = 0;
            newData = toSelectResponsables
              .map((el, index) => {
                if (el.is_active) {
                  maxN = index + 1;
                  return {
                    value: el[col.el_to_extract_from],
                    name: `${el.name} ${el.lastname}`,
                    img: el.image,
                    tasks: [],
                    id: index + 1
                  };
                } else {
                  return null;
                }
              })
              .filter((el) => el);
            /** Bug fix: 278 airtable ID */
            newData.push({
              value: null,
              name: t('filters_label.no_responsible'),
              img: null,
              tasks: [],
              id: maxN + 1
            });
          } else if (col.from_values.length) {
            let newSpace = col.from_values;
            if (col.mixed) {
              newSpace = col.from_values.filter((from) => {
                if (col.mixed_from.includes(from.value)) {
                  return false;
                } else {
                  return true;
                }
              });
            }
            newData = newSpace.map((el, index) => {
              let name = el.label;
              if (col.name === 'subcontractId') {
                const sub =
                  subContracts &&
                  subContracts.find((sub) => sub.id === el.value);
                if (sub) {
                  name = sub.name;
                }
              }
              return {
                value: el.value,
                tasks: [],
                label: el.label,
                name: name,
                id: index + 1
              };
            });
          }

          newDataActivity.map((activity) => {
            activity.tasks.map((task) => {
              newData.map((singleParent) => {
                /** Save object reference */
                task.activityObject = activity;
                if (col.name == 'responsables') {
                  if (task[col.name].length) {
                    task[col.name].map((responsable) => {
                      if (
                        responsable[col.el_to_extract_from] ==
                        singleParent.value
                      ) {
                        task.parentIdForGantt = singleParent.id;
                        singleParent.tasks.push(task);
                      }
                    });
                  } else if (!singleParent.value) {
                    task.parentIdForGantt = singleParent.id;
                    singleParent.tasks.push(task);
                  }
                } else {
                  if (task[col.name] == singleParent.value) {
                    task.parentIdForGantt = singleParent.id;
                    singleParent.tasks.push(task);
                  }

                  if (task.children.length && activity.unique_id) {
                    const allDeepTasks = getFlattenTasks(
                      task.children,
                      activity
                    );
                    if (allDeepTasks.length) {
                      allDeepTasks.map((taskDeep) => {
                        const findXx = singleParent.tasks.find(
                          (el1) => el1.id === taskDeep.id
                        );
                        if (!findXx) {
                          if (taskDeep[col.name] == singleParent.value) {
                            if (
                              taskDeep.activityObject === null ||
                              taskDeep.activityObject === undefined
                            ) {
                              taskDeep.activityObject = activity;
                            }
                            taskDeep.parentIdForGantt = singleParent.id;
                            singleParent.tasks.push(taskDeep);
                          }
                        }
                      });
                    }
                  }
                }
              });
            });
          });
          data = newData;
          data.sort(
            firstBy('value', { direction: newGroupBy.sort, ignoreCase: true })
          );
        }
      }
    }

    defaultView.current.group_query = JSON.stringify(newGroupBy);
    setGroupBy({ ...newGroupBy });
    window.groupBy = { ...newGroupBy };
    updateRender(data);
    setIsTree({ ...isTree });

    // if (defaultView.current.module == 'Masterplan_gantt') {
    //    if (groupBy.criteria != 'activityId' && newGroupBy.criteria == 'activityId') {
    //        setShouldDestroyGantt(true)
    //    }
    // }
  };

  const copyColumnTemplate = (tablePreferenceConfig, typeFrom) => {
    return tablePreferenceConfig.map((column) => {
      if (
        !column.template ||
        column.name == 'subcontractId' ||
        column.name == 'tags'
      ) {
        const originalCol = tableConfig.find(
          (originalCol) => originalCol.name === column.name
        );
        if (originalCol && !column.template) {
          column.template = originalCol.template;
          column.calculated = originalCol.calculated;
          column.editor = originalCol.editor;
        }

        if (
          column.data_type &&
          (column.data_type.includes('/icon') ||
            column.data_type.includes('/string'))
        ) {
          column.label = t('tables.lookahead.plan.' + column.name + '.label');

          if (!column.avoid_translate) {
            column.from_values.map((option) => {
              option.label = t(
                'tables.lookahead.plan.' +
                column.name +
                '.options.' +
                option.value
              );
            });
          }

          typeFrom[column.name] &&
            (column.from_values = typeFrom[column.name].from_values);
        } else {
          column.label = t('tables.lookahead.plan.' + column.name);
        }
      }

      if (
        column.name == 'path' ||
        (column.name == 'taskRoute' && !column.filterable)
      ) {
        column.name = 'taskRoute';
        column.filterable = true;
      }
      return column;
    });
  };

  const missingOriginalColumns = (tablePreferenceConfig) => {
    const diffs = diffTableConfigColumns(tablePreferenceConfig, tableConfig);
    diffs.forEach((columnConfig) => {
      const originalColPosition = tableConfig.findIndex(
        (col) => col.name == columnConfig.name
      );
      tablePreferenceConfig.splice(originalColPosition, 0, columnConfig);
    });
  };

  const isColumnFeatureOn = (newCol) => {
    if (
      defaultView.current.name == 'gantt' &&
      typeof newCol?.ganttNewColumns == 'boolean' &&
      !newCol.ganttNewColumns
    ) {
      return true;
    }

    return false;
  };

  const removeColumnsDuplicated = (tablePreferenceConfig = [], table) =>
    tablePreferenceConfig
      .map((col) => col.name)
      .map(
        (colName, idx, columnsName) =>
          columnsName.indexOf(colName) === idx && idx
      )
      .filter((col) => tablePreferenceConfig[col])
      .map((col) => tablePreferenceConfig[col])
      .filter((col) => {
        const newCol = table.find((column) => column.name == col.name);
        tablePreferenceConfig.forEach((column) => {
          if (column.name == col.name && newCol) {
            column.filterable = newCol.filterable;
            column.groupable = newCol.groupable;
            column.orderable = newCol.orderable;
            column.orderable_switch = newCol.orderable_switch;
          }
        });

        if (isColumnFeatureOn(newCol)) return false;

        newCol?.ignoreGantt && (col.ignoreGantt = true);
        newCol?.ganttOnly && (col.ganttOnly = true);

        return newCol;
      });

  const removeVisibleColumnsByView = (table) => {
    if (defaultView.current.name == 'gantt') {
      return table.filter((col) => !col.ignoreGantt);
    }

    return table.filter((col) => !col.ganttOnly);
  };

  const modifyLeanStatusColor = (table) => {
    const colIdx = table.findIndex((col) => col.name == 'lean_status');
    if (colIdx < 0) return;
    table[colIdx].from_values = leanStatusArray;
    return table;
  };

  /**
   * This function get activities and responsables to use them at DOM
   */
  async function getLookahead(dateRangeData = dateRange) {
    setMassiveSelection([]);
    setCurrentPage(0);

    let dateStart = dateRangeData.start;
    let dateEnd = dateRangeData.end;
    const sectorRes = await sectorService.showCalendar(
      projectState.sectorSelected
    );
    const currentView = listView.current.find(findView);

    if (currentView && currentView.view && currentView.view.activityTreeSettings) {
      dateStart = currentView.view.activityTreeSettings.start || dateRangeData.start;
      dateEnd = currentView.view.activityTreeSettings.end || dateRangeData.end;
    }

    const sector = sectorRes.sector;
    setSectorObject(sector);

    const getLookaheadBody = {
      sector_id: projectState.sectorSelected,
      start: dateStart,
      end: dateEnd,
      include_milestone: false
    };

    if (isLWP18) {
      if (
        defaultView &&
        defaultView.current &&
        defaultView.current.module == 'Masterplan_gantt'
      ) {
        getLookaheadBody.include_milestone = true;
      }
    }

    const ids = currentView?.view?.activityTreeSettings?.activitieIds.length
      ? currentView.view.activityTreeSettings.activitieIds.map((activity) =>
        isNaN(activity) ? activity : activity
      )
      : [];

    const activitiesIds = {
      sector_id: projectState.sectorSelected,
      ids: ids
    };
    setGetLookaheadInMassive({
      ...activitiesIds,
      include_milestone: getLookaheadBody.include_milestone
    });
    const lastLevelActivities = ids.length
      ? await activityService.getLookaheadIds({
        ...activitiesIds,
        include_milestone: getLookaheadBody.include_milestone
      })
      : await activityService.getLookahead({ ...getLookaheadBody });
    setLastLevelActivitiesCard(lastLevelActivities);
    const activities = lastLevelActivities?.activities || [];
    window.activities = activities;
    window.activitiesMap = buildTaskMap(activities);
    window.activitiesMapActivity = buildActivityMap(activities);
    allActivitiesRef.current = cloneDeep(lastLevelActivities);
    const resources = lastLevelActivities.resource || [];
    const responsables = await userService.getBySector(
      projectState.sectorSelected
    );
    const { tag } = await tagService.showByProject(
      projectState.projectSelected
    );

    setTaktRelations(lastLevelActivities.taktRelations);

    const data = lastLevelActivities.activities?.sort(
      firstBy('id', { direction: 'asc', ignoreCase: true })
    );

    const calendars = await calendarService.showBySector(
      projectState.sectorSelected
    );

    /** get Subcontracts */
    const subcontractsGet = await subContractService.getByProject(
      projectState.projectSelected
    );

    if (subcontractsGet) {
      const typeFrom = {
        subcontractId: { from_values: [] },
        tags: { from_values: [] }
      };
      const subContractsOrdered = subcontractsGet.subcontracts.sort(
        dynamicSort('name')
      );

      subContractsOrdered.forEach((type, index) => {
        typeFrom.subcontractId.from_values.push({
          value: type.id,
          label: type.name,
          weigth: index + 1
        });
      });

      tag.forEach((type, idx) => {
        typeFrom.tags.from_values.push({
          value: type.id,
          label: type.name,
          weigth: idx + 1
        });
      });

      if (!defaultView.current.name && listView.current.length) {
        const configView = listView.current[0];
        await viewService.update({
          projectId: configView.project,
          sectorId: configView.sector,
          ganttChart: configView.ganttChart,
          orderView: configView.order,
          ...configView.view,
          default: true
        });
      }

      let tablePreferenceConfig = currentView?.view.columns_json?.settings
        ? [...currentView.view.columns_json.settings]
        : tableConfig;

      /** Connect resources data with current view and it's configuration */
      const materialFrom = tablePreferenceConfig.find(
        (col) => col.identifier == 'material'
      );
      const machineryFrom = tablePreferenceConfig.find(
        (col) => col.identifier == 'machinery'
      );
      const specialityFrom = tablePreferenceConfig.find(
        (col) => col.identifier == 'rrhh'
      );
      materialFrom &&
        materialFrom.from_values &&
        materialFrom.from_values.splice(0, materialFrom.from_values.length);
      machineryFrom &&
        machineryFrom.from_values &&
        machineryFrom.from_values.splice(0, machineryFrom.from_values.length);
      specialityFrom &&
        specialityFrom.from_values &&
        specialityFrom.from_values.splice(0, specialityFrom.from_values.length);

      resources.map((resource, index) => {
        const toPush = {
          value: resource.id,
          label: resource.name,
          weigth: index + 1,
          plain: resource
        };

        switch (resource.type) {
          case 'material':
            materialFrom && materialFrom.from_values.push(toPush);
            break;
          case 'machinery':
            machineryFrom && machineryFrom.from_values.push(toPush);
            break;
          case 'rrhh':
            specialityFrom && specialityFrom.from_values.push(toPush);
            break;
        }
      });

      setResourceOptions({
        materials: materialFrom?.from_values || [],
        machineries: machineryFrom?.from_values || [],
        specialties: specialityFrom?.from_values || []
      });

      tablePreferenceConfig = copyColumnTemplate(
        tablePreferenceConfig,
        typeFrom
      );

      if (availableTableMetadata.length > tablePreferenceConfig.length) {
        missingOriginalColumns(tablePreferenceConfig);
      }

      tablePreferenceConfig = modifyLeanStatusColor(tablePreferenceConfig);
      tablePreferenceConfig = removeColumnsDuplicated(
        tablePreferenceConfig,
        availableTableMetadata
      );
      tablePreferenceConfig = removeVisibleColumnsByView(tablePreferenceConfig);

      const viewConfigIdx = listView.current.findIndex(findView);
      if (
        typeof listView.current[viewConfigIdx].view.columns_json == 'string'
      ) {
        listView.current[viewConfigIdx].view.columns_json = JSON.parse(
          listView.current[viewConfigIdx].view.columns_json
        );
      }

      listView.current[viewConfigIdx].view.columns_json.settings =
        tablePreferenceConfig;

      defaultView.current.columns_json = {
        ...defaultView.current.columns_json,
        settings: tablePreferenceConfig
      };

      setTableConfig(cloneDeep(tablePreferenceConfig));
      setSubcontracts(subContractsOrdered);
      updateSubContractGanttView(subContractsOrdered, gantt);
    }

    /** If data were fetch succesfully, we pass this data to component states */
    if (lastLevelActivities) {
      setResourcesCard(resources);
      const toLoadActivities = data.sort(
        (a, b) => parseInt(a.correlative_id) - parseInt(b.correlative_id)
      );
      setActivities(toLoadActivities);
      currentActivities.current = data;
      loadStoredGroupQuery(data);

      const all = data.map(async (ac) => {
        if (ac.tasks.length && !ac.isOnLookahead) {
          const s = await activityService.assignLookahead({
            id: ac.id,
            is_lookahead: true
          });
          ac.isOnLookahead = true;
        } else if (!ac.tasks.length && ac.isOnLookahead) {
          const s = await activityService.assignLookahead({
            id: ac.id,
            is_lookahead: false
          });
          ac.isOnLookahead = false;
        }
      });

      await Promise.all(all);

      if (responsables) {
        setToSelectResponsables(
          responsables.users.filter((r) => r && r.is_active)
        );
        getTags(toLoadActivities);
        setTags(tag);
      }

      !gantt && setGantt(GanttDhtmlx.getGanttInstance());
      calendars.calendar.map((calendar) => {
        const temp_shitps = [];
        calendar.shifts.map((shift) => {
          if (shift) {
            const array_shift = shift.shift_string.split(',');
            const validate = checkArrayEqualElements(array_shift);
            if (validate) {
              temp_shitps.push(shift);
            }
          }
        });
        calendar.shifts = temp_shitps;
      });
      setCalendars(calendars.calendar);
      setReloadDataViwes(false);
    }

    return data;
  }

  useEffect(() => {
    if (isLookaheadFullLoaded) {
      setReloadDataViwes(false);
      gantt.scrollToTodayAtChart && gantt.scrollToTodayAtChart();
    }
  }, [isLookaheadFullLoaded]);

  useEffect(() => {
    if (isLoading) return;
    const foundView = listView.current.find(findView);

    const sectorKey = sessionStorage.getItem('currentSector');
    const presetWeekRange = 4;

    if (!isLoading && foundView && sectorKey) {
      const currentView = foundView;
      const currentSector = JSON.parse(sectorKey);
      const currentScale = JSON.parse(localStorage.getItem('scale')) || 'days';
      const currentBarColor = currentView?.view?.colorSchema ?? 'Status';
      const valuesFiltersApplied = obtainKeyValuesOfArray(
        currentView,
        'filter_query',
        'name'
      );
      const valuesSortApplied = obtainKeyValuesOfArray(
        currentView,
        'order_query',
        'name'
      );
      const rangeSelected =
        currentView?.view?.activityTreeSettings?.range ?? presetWeekRange;

      trackingEvent(
        'lookahead_visualization',
        {
          ...getBasicAmplitudEventProperties(),
          column_filter_applied: valuesFiltersApplied,
          columns_activated: currentView?.view.columns_json.columnsActive,
          sorting_applied: valuesSortApplied,
          zoom_scale_selected: currentScale,
          bar_color_option_active: currentBarColor,
          date_format_selected: currentSector?.dateFormat,
          time_frame_selected: rangeSelected,
          view_type: currentView?.view.name,
          rolling_status: currentView?.view.rollingStatus
        },
        AMPLITUDE_SERVICE
      );
    }

    if (!isLoading) {
      setIsLookaheadFullLoaded(true);
    }
  }, [isLoading]);

  function checkArrayEqualElements(_array) {
    for (var i = 0; i < _array.length; i++) {
      if (_array[i] != 'false' && _array[i] != 'false-false') {
        return true;
      }
    }
    return false;
  }

  const isGanttView = (defaultGanttFields, findIdx, metadata) => {
    const isGantt = listView.current[findIdx].view.name === 'gantt';
    // Set Default gantt fields
    if (isGantt) {
      metadata.forEach((field) => {
        if (!defaultGanttFields.includes(field.name)) field.hide = true;
      });
    }
    return isGantt;
  };

  const resizeGridTimeline = async (newWidth, indexView) => {
    listView.current[indexView].ganttChart = newWidth;
    defaultView.current.ganttChart = newWidth;
    await viewService.update({
      ...defaultView.current,
      projectId: listView.current[indexView].project,
      sectorId: listView.current[indexView].sector,
      ganttChart: newWidth,
      orderView: listView.current[indexView].order
    });
  };

  const saveColumnOrderTimeline = ({
    draggedColumn,
    targetColumn,
    draggedIndex,
    targetIndex
  }) => {
    if (columnTimelineMoved.current) {
      columnTimelineMoved.current = false;
      return;
    }

    const findIdx = listView.current.findIndex(findView);

    defaultView.current.columns_json.settings.splice(draggedIndex, 1);
    defaultView.current.columns_json.settings.splice(
      targetIndex,
      0,
      draggedColumn
    );

    listView.current[findIdx].view.columns_json.settings =
      defaultView.current.columns_json.settings;

    columnTimelineMoved.current = true;
    viewService.update({
      projectId: listView.current[findIdx].project,
      sectorId: listView.current[findIdx].sector,
      ganttChart: listView.current[findIdx].ganttChart,
      orderView: listView.current[findIdx].order,
      ...defaultView.current
    });
  };

  window.saveColumnOrderTimeline = saveColumnOrderTimeline

  const resizeColumnsTimeLine = ({ columnRizised = false, newWidth }) => {
    const findIdx = listView.current.findIndex(findView);

    if (!columnRizised) {
      return resizeGridTimeline(newWidth, findIdx);
    }

    defaultView.current.columns_json.settings.forEach((column) => {
      if (column.name == columnRizised.name) {
        column.width = newWidth && (column.width = newWidth);
      }
    });

    listView.current[findIdx].view.columns_json.settings.forEach((column) => {
      column.name == columnRizised.name && (column.width = newWidth);
    });

    viewService.update({
      projectId: listView.current[findIdx].project,
      sectorId: listView.current[findIdx].sector,
      ganttChart: listView.current[findIdx].ganttChart,
      orderView: listView.current[findIdx].order,
      ...defaultView.current
    });
  };

  /**
   * This function updates the state of table metadata
   * @param {*} tMetadata Object with same attr than tableConfig to replace at view state
   * @param {*} isRendering defines if there is other rendering react process already in execution
   * @param {*} isChangeColVisibility Boolean which defines if something has change for cols definition
   */
  async function updateTableMetadata(
    tMetadata = tableConfig,
    isRendering = false,
    isChangeColVisibility = false,
    { isPreview = false } = {}
  ) {
    let metadata = tMetadata.length ? tMetadata : availableTableMetadata;

    if (isPreview) {
      return setTableConfig(cloneDeep(metadata));
    }
    if (!defaultView.current.name) {
      return setTableConfig((prev) => {
        prev = cloneDeep(metadata);
        return prev;
      });
    }
    const findIdx = listView.current.findIndex(findView);
    const isGantt = isGanttView(defaultGanttFields, findIdx, metadata);

    if (!defaultView.current?.columns_json.settings) {
      const activated = availableTableMetadata
        .filter((col) => col.visible)
        .map((col) => col.name);

      listView.current[findIdx].view.columns_json = {
        settings: availableTableMetadata,
        columnsActive: isGantt ? defaultGanttFields : activated
      };

      defaultView.current.columns_json = {
        settings: availableTableMetadata,
        columnsActive: isGantt ? defaultGanttFields : activated
      };

      return setTableConfig(defaultView.current.columns_json.settings);
    }

    const lookforNewColumns = !defaultView.current.beta;
    if (defaultView.current.name === 'table') {
      metadata = resizeNameTaskColumn(metadata, width);
      metadata = handleLeanStatusColPosition(
        metadata,
        isChangeColVisibility,
        leanStatusColVisibility
      );
    }
    const columnSettings = defaultView.current.columns_json;

    if (columnSettings.settings && !isChangeColVisibility && isRendering) {
      const findIdx = listView.current.findIndex(findView);
      let activated =
        isGantt && !columnSettings.columnsActive?.length
          ? defaultGanttFields
          : columnSettings.columnsActive;

      /** check if new fields was added */
      const lastFieldsToAdd = fieldsOnlyForGanttView;
      let settings = columnSettings.settings;
      if (lookforNewColumns) {
        const fieldsNameAdded = lastFieldsToAdd;

        if (fieldsNameAdded.length) {
          // get the configuration object of the new columns to add
          const fieldsAdded = metadata.filter((config) =>
            fieldsNameAdded.includes(config.name)
          );

          // find the index of name (always fixed)
          const idxName = columnSettings.settings.findIndex(
            (col) => col.name === 'name'
          );
          if (idxName !== -1) {
            if (columnSettings?.settings?.length) {
              /** update settings in view */
              const newArraySettings = [
                ...columnSettings.settings.slice(0, idxName + 1),
                ...fieldsAdded,
                ...columnSettings.settings.slice(idxName + 1)
              ];
              settings = newArraySettings;
            } else {
              settings = metadata;
            }

            if (columnSettings?.columnsActive?.length) {
              /** update columnsActive in view */
              const newArrayActivated = [
                ...columnSettings.columnsActive.slice(0, idxName + 1),
                ...fieldsNameAdded,
                ...columnSettings.columnsActive.slice(idxName + 1)
              ];
              activated = newArrayActivated;
            } else {
              activated = defaultGanttFields;
            }
            defaultView.current.beta = true;
          }
        }
      }

      listView.current[findIdx].view.columns_json = {
        settings,
        columnsActive: activated
      };

      defaultView.current.columns_json = {
        settings,
        columnsActive: activated
      };

      !isRendering &&
        (await viewService.update({
          projectId: listView.current[findIdx].project,
          sectorId: listView.current[findIdx].sector,
          ganttChart: listView.current[findIdx].ganttChart,
          orderView: listView.current[findIdx].order,
          ...defaultView.current
        }));

      setTableConfig(settings);
      return;
    }

    setTableConfig(cloneDeep(metadata));
  }

  /**
   * This functions update the state of activities at view
   */
  const updateRender = (ac = activities) => {
    setActivities((prevActivities) => {
      const arrayToUse = ac || prevActivities;
      window.activities = arrayToUse;
      window.activitiesMap = buildTaskMap(arrayToUse);
      window.activitiesMapActivity = buildActivityMap(arrayToUse);
      return [...arrayToUse];
    });
  };

  /**
   * This function is used by datepickers to save new valeus to component state
   * @param {*} _value Moment date object
   * @param {*} dateString String date
   */
  const changeDateState = async (_, dateString, range) => {
    if (dateString[0] != '' && dateString != '') {
      setDateRange((prev) => {
        prev.start = dateString[0];
        prev.end = dateString[1];
        return prev;
      });
      setGroupBy((prev) => {
        prev = { criteria: 'activityId', sort: 'asc' };
        return prev;
      });

      window.groupBy = { criteria: 'activityId', sort: 'asc' };

      const viewConfigIdx = listView.current.findIndex(findView);
      listView.current[viewConfigIdx].view.lookahead_init = dateRange.start;
      listView.current[viewConfigIdx].view.lookahead_end = dateRange.end;

      defaultView.current.lookahead_init = dateRange.start;
      defaultView.current.lookahead_end = dateRange.end;

      if (range) {
        const dateRangeMsg = range > 1 ? `${range} Weeks` : 'This Week';
        listView.current[viewConfigIdx].view.lookahead_range = dateRangeMsg;
        defaultView.current.lookahead_range = dateRangeMsg;
      } else {
        listView.current[viewConfigIdx].view.lookahead_range = 'free range';
        defaultView.current.lookahead_range = 'free range';
      }

      dispatch(lookaheadActions.setLookaheadViewsConfig(listView.current));
      getLookahead();
    } else {
      setActivities([]);
    }
  };

  /**
   * This function executes massiveSelectionHandler then sets the selection state to
   * handle massive actions like deleting, changing responsable, etc.
   * @param {*} selection Initial selection
   */
  const recursivelySelection = (selection) => {
    /** Temporal array to save added task */
    const toAdd = [];

    /** Temporal array to save deleted task */
    const toDelete = [];

    /** Execution of recursively selection */
    massiveSelectionHandler(selection, null, toAdd, toDelete);

    /** Setting state of massive actions */
    setMassiveSelection((prev) => {
      /* Take off elements of massive actions state */
      const newState = differenceBy(prev, toDelete, 'id');

      /** Then we check those elements that arent at the state and add them */
      toAdd.forEach((el) => {
        const doesExist = newState.find((single) => el.id == single.id);
        if (!doesExist) {
          /** Filter if it is a task (avoid adding activities) */
          if (!el.hide && (el.children || el.activityId)) {
            newState.push(el);
          }
        }
      });

      prev = cloneDeep(newState);
      return prev;
    });
  };

  /**
   * This function handles with massive selection tasks
   * @param {*} selection Element to change selecton status by it active attribute
   * @param {*} flag This saves the parent selected status to match with their children
   * @param {*} toAdd Array with tasks to add to state array with massive selection
   * @param {*} toDelete Array with tasks to delete from state array with massive selection
   */
  const massiveSelectionHandler = (
    selection,
    flag = null,
    toAdd = [],
    toDelete = []
  ) => {
    const originalSelectionValue = selection.active;

    /** Define array of children (activity or task) */
    const childs = selection.tasks || selection.children;

    /** Defines first flag value from calling this function without flag */
    if (flag == null) {
      flag = !selection.active;
      selection.active = !selection.active;
    }

    /** Matchs the values to dont change already setted correct value */
    if (flag != selection.active) {
      selection.active = !selection.active;
    }

    /** Defines if the current selection must be deleted or added to state array of massive selection */
    if (
      selection.editablePermissionACP &&
      !selection.editablePermissionACP.editable
    ) {
      selection.active = originalSelectionValue;
    } else if (selection.active) {
      toAdd.push(selection);
    } else if (!selection.active) {
      toDelete.push(selection);
    }

    if (defaultView.current.name != 'gantt') {
      if (childs) {
        if (childs.length) {
          childs.map((el) => {
            massiveSelectionHandler(el, flag, toAdd, toDelete);
          });
        }
      }
    } else {
      /** Recursively repetition for children */
      if (groupBy.criteria == 'activity' || groupBy.criteria == 'activityId') {
        if (childs) {
          if (childs.length) {
            childs.map((el) => {
              massiveSelectionHandler(el, flag, toAdd, toDelete);
            });
          }
        }
      } else {
        if (childs && !selection.children) {
          if (childs.length) {
            childs.map((el) => {
              massiveSelectionHandler(el, flag, toAdd, toDelete);
            });
          }
        }
      }
    }
  };

  /**
   * This function handles the drag n drop movements for change cols disposition
   * @param {*} oldIndex Index from the array that is dragged
   * @param {*} newIndex Index from the element that the dragged el is going to be moved
   */
  const moveCard = async ({ oldIndex, newIndex }) => {
    const dragCard = tableConfig[oldIndex];

    const a = update(tableConfig, {
      $splice: [
        [oldIndex, 1],
        [newIndex, 0, dragCard]
      ]
    });
    updateTableMetadata(a);
  };

  const onDoubleClickTask = (task) => {
    if (task.isTask) {
      let activityReference;
      let doesExistAtReference;
      if (defaultView.current.name == 'gantt') {
        if (!task.activityReference.proplannerId) {
          const tasks = activities.reduce((acc, next) => {
            acc.push(next.tasks);
            return acc.flat();
          }, []);
          activityReference = tasks.find((tk) => tk.id == task.id);
          doesExistAtReference = getTask(
            task.id,
            null,
            activityReference.activityObject
          );
        } else {
          activityReference = activities.find(
            (ac) => ac.id == task.activityReference.proplannerId
          );
          doesExistAtReference = getTask(task.id, null, activityReference);
        }
      } else if (defaultView.current.name == 'takt') {
        activityReference = activities.find(
          (activity) => activity.id == task.activityId
        );
        doesExistAtReference = getTask(task.id, null, activityReference);
      } else if (defaultView.current.name == 'table') {
        activityReference = activities.find(
          (activity) => activity.id == task.id
        );
        doesExistAtReference = getTask(task.id, null, activityReference);
      }
      showDrawer(doesExistAtReference[0], activityReference);
    }
  };

  /** this function set to null subcontractId */
  const deleteSubcontract = (task, activity) => {
    const doesExistAtReference = getTask(task.id, null, activity);
    if (doesExistAtReference.length) {
      const reference = doesExistAtReference[0];
      reference.subcontractId = null;
      const copy = cloneDeep(task);
      taskService.removeSubcontract(task.id);

      if (defaultView.current.name == 'gantt') {
        const gantt = window.ganttVisualization;
        const objectGantt = gantt.getTask(task.id);
        objectGantt.subcontractId = null;
        gantt.updateTask(objectGantt.id);
      }
      // socket.emit('task_update', {
      //     sector: projectState.sectorSelected,
      //     task: copy
      // })
    }
    handlePopVisibility(false, 'deleteSubcontract');
  };

  const handleAddConstraint = (task) => {
    const tasks = Array.isArray(task) ? [...task] : [task];
    setVisibleForm({ value: true, tasks: tasks });
  };

  const handleUpdatedTasksResponsables = (t, updatedTask) => {
    activities.map((el) => {
      /** Then get the reference from state */
      const taskToUpdate = getTask(t.id, null, el);

      /** Finally we just update the constraints array from the referenced task */
      if (taskToUpdate.length) {
        taskToUpdate[0].constraints = updatedTask.constraints;
        // socket.emit('task_update', {
        //     sector: projectState.sectorSelected,
        //     task: updatedTask
        // })
      }
    });
  };

  const handleUpdatedTasks = async (updatedTasks = false) => {
    if (updatedTasks) {
      if (updatedTasks.length) {
        const asyncFeature = updatedTasks.map(async (t) => {
          /** First we fetch the updated task */
          let updatedTask = await taskService.show(t.id);
          if (updatedTask) {
            updatedTask = updatedTask.task;
            let activity;
            const { criteria } = groupBy;
            /** Check if the groupping if by activity */
            if (criteria == 'activity' || criteria == 'activityId') {
              /** Get activity */
              activity = activities.find((ac) => ac.id == t.activityId);
            } else {
              /** If is by responsable we iterate each one, and update it list task */
              if (criteria == 'responsables') {
                return handleUpdatedTasksResponsables(t, updatedTask);
              } else {
                /** We get the attribute value and filter whole array of parents (activity just to not broke the code) */
                activity = activities.find((ac) => ac.value == t[criteria]);
              }
            }

            /** Then get the reference from state */
            const taskToUpdate = getTask(t.id, null, activity);

            /** Finally we just update the constraints array from the referenced task */
            if (taskToUpdate.length) {
              taskToUpdate[0].constraints = updatedTask.constraints;
              if (gantt) {
                const ganttRefTask = gantt.getTask(taskToUpdate[0].id);
                if (ganttRefTask) {
                  ganttRefTask.constraints = taskToUpdate[0].constraints;
                  ganttRefTask.restricted = true;
                }
              }
              // socket.emit('task_update', {
              //     sector: projectState.sectorSelected,
              //     task: updatedTask
              // })
            }
          }
        });
        await Promise.all(asyncFeature);
        gantt &&
          gantt.callbackAfterAddConstraint &&
          gantt.callbackAfterAddConstraint(updatedTasks);
        updateRender();
      }
    }
  };

  const getParentsFromActivityRoute = (activities) => {
    let final = [];
    activities.map((activity) => {
      const routeIds = activity.activityRouteIds;
      if (activity.activityRoute) {
        const names = activity.activityRoute.split('>');
        names.map((_name, i) => {
          final.push({ ...routeIds[i], isProject: true });
        });
      }
    });
    final = final.filter((v, i, a) => a.findIndex((t) => t.id === v.id) === i);
    return final;
  };

  const updateGanttVisualizationState = () => {
    if (timelineState.value) return;

    /** First load array for tasks at gantt */
    /** main is custom type in proplanner to indetify first level of activities, and under this, print their tasks */
    let final = [];
    const mainParents = activities.map((activity) => {
      if (groupBy.criteria != 'activityId') {
        const parentby = activity;
        return {
          name: parentby.name,
          id: parentby.id,
          unique_id: parentby.id,
          type: parentby.type,
          tasks: parentby.tasks,
          activityRoute: ''
        };
      } else {
        return convertPPActivity2PluginTask(activity);
      }
    });

    const activitiesWithChilds = getParentsFromActivityRoute(mainParents);
    const transformedActivitiesWithChilds = activitiesWithChilds.map((el) => {
      const trans = convertPPActivity2PluginTask(el);
      return trans;
    });

    const hashIdToUnique = {};
    const mixed = isLWP18
      ? mainParents
      : [...mainParents, ...transformedActivitiesWithChilds];
    mixed.map((activity) => {
      hashIdToUnique[activity.proplannerId] = activity.id;
    });
    /**
     * This map executes a method recursively, which go deeply and populate mainParents to use as final array to load
     */
    mainParents.map((mainLvlGanttTask) => {
      final.push(mainLvlGanttTask);
      /**
       * This side must be recursive for go getting deeply the data and create on real time
       */
      recursiveTransformForTasks(mainLvlGanttTask, final, hashIdToUnique);
      delete mainLvlGanttTask.tasks;
    });

    final.map((f, index) => {
      f.ganttId = f.correlative_id;
      f.correlative_id = index;
    });

    /** This is commented til this works at least with tasks */
    const links = [];

    if (groupBy.criteria == 'activityId' && !isLWP18) {
      final = [...final, ...transformedActivitiesWithChilds];
    } else {
      final = [...final];
    }

    if (groupBy.criteria != 'activityId') {
      final.forEach((activity) => {
        if (!activity.start_date) {
          activity.start_date = new Date();
          activity.duration = 1;
        }
      });
    }
    window.ganttData = final
    setGanttData({ data: final, links });
  };

  const handleUnfit = (task) => {
    const activity = task.activityReference;
    setModalModification({
      ...modalModification,
      visible: true,
      title: t('modals.lookahead.activity_modification_request.title'),
      data: {
        task: {
          ...task,
          start_date: task.non_parsed_original_start_date,
          end_date: task.non_parsed_original_end_date
        },
        activity: {
          ...activity,
          start_date: activity.non_parsed_original_start_date,
          end_date: activity.non_parsed_original_end_date,
          id: activity.proplannerId
        }
      }
    });
  };

  const renderExtraItemsFilter = () => {
    const leanStatusArray = tableConfig.length
      ? tableConfig.find((el) => el.name === 'lean_status')
      : null;
    let statusSort = [];
    if (leanStatusArray) {
      statusSort = cloneDeep(leanStatusArray.from_values);
      const rest = statusSort.find((el) => el.value === 'Restricted');
      const newarr = statusSort.splice(3, 0, rest);
      statusSort.shift();
    }
    return leanStatusArray ? (
      <div className="indicators-btn">
        <div className={`indicators ${indicatorVisible ? null : 'hide'}`}>
          <div className="lean">
            <Switch
              checkedChildren="%"
              unCheckedChildren="Un"
              checked={indicatorPercentage}
              onChange={(checked) => {
                setIndicatorPercentage(checked);
              }}
              size="small"
            />
            <div className="lean-info">
              {indicators.total} {t('tasks_only_label')}
            </div>
          </div>
          <div className="status-arr">
            {statusSort.map((el, index) => {
              return (
                <div
                  key={index}
                  className="status-arr-item"
                  style={{ color: el.color }}>
                  <div>{el.label}</div>
                  <div className="count-tasks">
                    {indicatorPercentage
                      ? (parseFloat(
                        (100 * (indicators[el.value] || 0)) / indicators.total
                      ).toFixed(1) || 0) + '%'
                      : indicators[el.value] || 0}
                  </div>
                </div>
              );
            })}
          </div>
          <CloseOutlined
            className="close"
            onClick={() => setIndicatorVisible(false)}
          />
        </div>
        <div
          // className="indicators-icon"
          className={`indicators-icon ${indicatorVisible ? 'hidden' : null}`}
          onClick={() => setIndicatorVisible(true)}>
          <Tooltip placement="top" title={t('indicators_label_only')}>
            <img
              width={12}
              src={indicatorIcon}
              style={{ top: -1, position: 'relative' }}
            />
          </Tooltip>
        </div>
      </div>
    ) : null;
  };

  /**
   * This function returns the reference of an activity from state
   * @param {*} id ID of activity to get (REQUIRED)
   */
  const getActivity = (id) => {
    const activity = activities.find((ac) => ac.id == id);
    return activity;
  };

  /**
   * This function return the reference from the state for activity and parent task
   * @param {*} activityId ID of the activity
   * @param {*} parentId ID of the parent
   */
  const getActivityAndParentReference = (activityId, parentId) => {
    /** Get reference of the activity of current iteration */
    const activity = getActivity(activityId);

    let parentTask = null;

    /** If current iteration has a parent task, we load it */
    if (parentId) {
      parentTask = getTask(parentId, null, activity);
      if (parentTask.length) {
        parentTask = parentTask[0];
      }
    }

    return { activity, parentTask };
  };

  const updateAsyncTask = (task) => {
    const copy = cloneDeep(task);
    delete copy.activityObject;
    delete copy.activityReference;
    if (copy.activityId) {
      taskService.update(copy);
    }
    // socket.emit('task_update', {
    //     sector: projectState.sectorSelected,
    //     task: copy
    // })
    if (defaultView.current.name == 'gantt') {
      // const activityReference = activities.find(ac => ac.id == task.activityId)
      // const doesExistAtReference = getTask(task.id, null, activityReference)
      // Object.keys(task).map(key => {
      //     if (doesExistAtReference[0]) {
      //         doesExistAtReference[0][key] = task[key]
      //     }
      // })
    }

    if (indicatorVisible) buildIndicators();
  };

  const updateAsyncActivity = async (activity) => {
    try {
      await activityService.update(activity);
      await activityService.updateTreeProgress(activity.id);

      /** find activity on object allActivities (state that saves activities without reference) */
      const findAct = allActivitiesRef.current.activities.findIndex(
        (act) => act.id === activity.id
      );
      if (findAct !== -1) {
        /** found */
        /** compare activity modified vs activity previous state */
        if (
          parseFloat(allActivitiesRef.current.activities[findAct].progress) !==
          parseFloat(activity.progress)
        ) {
          const newActivityHistorical = {
            activityId: activity.id,
            progress: activity.progress
          };
          historicalActivityProgressService.create(newActivityHistorical);

          /** update state allActivities (without reference too) */
          const newActivity = cloneDeep(activity);
          const newActivities = cloneDeep(allActivitiesRef.current);
          newActivities.activities[findAct] = newActivity;
          allActivitiesRef.current = newActivities;
        }
      }
    } catch (error) {
      Sentry.withScope((scope) => {
        scope.setTags({
          planificationView: 'updateAsyncActivity'
        });
        Sentry.captureException(error);
      });

    }
  };

  /**
   * This function opens the constraint creation component with massive selection
   */
  const massiveConstraintHandler = () => {
    setVisibleForm({ value: true, tasks: massiveSelection });
  };

  const handlePopVisibility = async (visible, id) => {
    // setMassiveOnProcess(true)

    setPopsVisibility({
      ...popsVisibility,
      [id]: visible
    });
  };

  const createActivityModificationRequest = async (task, activity) => {
    const loggedUser = getSignedUser();
    if (!loggedUser) return;
    const projectId = projectState.projectSelected;
    const sectorId = projectState.sectorSelected;
    const link = base.front + 'masterplan/' + sectorId + '/' + projectId;

    const activityModification = {
      type: task.unfitType,
      state: 'waiting',
      description: modalModification.description,
      activityId: activity.id,
      userRequestId: loggedUser.id,
      startOriginal: activity.start_date,
      endOriginal: activity.end_date,
      user: loggedUser,
      projectId,
      sectorId,
      link
    };

    if (task.unfitType == 'start') {
      activityModification.startNew = task.start_date;
      activityModification.endNew = activity.end_date;
    } else if (task.unfitType == 'end') {
      activityModification.startNew = activity.start_date;
      activityModification.endNew = task.end_date;
    } else if (task.unfitType == 'both') {
      activityModification.startNew = task.start_date;
      activityModification.endNew = task.end_date;
    }
    const res = await activityModificationService.create(activityModification);
    dispatch(userActions.setUserUpdate());
    if (res) {
      openNotification({
        type: 'success',
        title: t('success_request_notify')
      });
      setModalModification({
        ...modalModification,
        visible: false
      });
    }
  };

  /** card functions */
  const showDrawer = async (task, activity) => {
    if (gantt && window.gantt) {
      gantt.isCardActive = true;
      window.gantt.isCardActive = true;
    }
    const newTask = cloneDeep(task);
    const newDuration = transformHourToDays(newTask.duration);
    newTask.duration = newDuration;

    setCurrentTask(newTask);
    setCurrentActivity(activity);
    setCardState({ visible: true });
  };

  const onCloseCard = () => {
    if (gantt && window.gantt) {
      gantt.isCardActive = false;
      window.gantt.isCardActive = false;
    }
    setCurrentTask(null);
    setCurrentActivity(null);
    setCardState({ visible: false });
  };

  /** this function close all popover  except uniqueIdConstraintDiff */
  const handlePopVisibilityCloseAll = async (uniqueIdConstraintDiff) => {
    const popArr = popsVisibility;
    Object.keys(popArr).forEach((v) => {
      if (uniqueIdConstraintDiff !== v) {
        popArr[v] = false;
      }
    });
    setPopsVisibility({
      ...popArr
    });
  };

  const handleInputChange = (key) => {
    setNumWeeks(key);
    setIsErrorForm(false);
  };

  const dateReportHandle = async (_date) => {
    const dateString = moment(_date).format('YYYY/MM/DD');
    setModelReportDateLookAhead(dateString);
    setIsErrorForm(false);
  };

  const activeLookAheadReportModal = async () => {
    trackingEvent(
      'start_lookahead_pdf_exportation',
      {
        ...getBasicAmplitudEventProperties()
      },
      AMPLITUDE_SERVICE
    );
    setModelReportLookAhead(!modelReportLookAhead);
  };

  const activeExportPdfModal = async () => {
    setIsExportPdfModalVisible(!isExportPdfModalVisible);
  };

  const renderTableView = (filterSettings) => {
    if (groupBy.criteria == 'activity' || groupBy.criteria == 'activityId') {
      return (
        <div
          className={cn({
            'activity-pane__container':
              isFeatureOn('enable-LWP-103') &&
              activeActivityTreePane &&
              !isLoading
          })}>
          {isFeatureOn('enable-LWP-103') &&
            activeActivityTreePane &&
            !isLoading && (
              <ActivityTreePane
                activities={activitiesTreePanel}
                actitySettings={defaultView.current.activityTreeSettings}
                closePane={setActiveActivityTreePane}
                filterSettings={filterSettings}
                onCommandDispach={getLookahead}
                viewId={defaultView.current.id}
                setActivityTreePaneSettings={setActivityTreePaneSettings}
                isReloadDataViews={isReloadDataViews}
                t={t}
                currentActivityHidden={currentActivityHidden}
              />
            )}
          {isReloadDataViews && (
            <div>
              <Spin
                className="loader-spinner-lookahead-table"
                indicator={antIcon}
              />
            </div>
          )}
          {!isReloadDataViews && (
            <CustomPaginator
              lookahead={true}
              scrollStates={scrollStates}
              totalTablesWidth={totalTablesWidth}
              massiveSelection={massiveSelection}
              resizing={resizing}
              current={currentPage}
              setCurrentPage={setCurrentPage}
              data={array}
              t={t}
              isFilterdData={existFilter}
              itemSize={height < 700 ? height * 0.55 : height * 0.68}
              renderItem={(item, key, virtualizeRef) => {
                if (key == 0) {
                  paginatorRef = virtualizeRef;
                  return item;
                } else if (!resizing) {
                  window.rowsActivities &&
                    window.rowsActivities.resetAfterRowIndex(0);
                  return (
                    <LookaheadActivity
                      subtradeRole={subtradeRole}
                      t={t}
                      permission={permission}
                      ganttAPI={ganttAPI}
                      isFilterdData={existFilter}
                      updateAsyncTask={updateAsyncTask}
                      updateAsyncActivity={updateAsyncActivity}
                      lastLevelActivities={lastLevelActivitiesCard}
                      scrollStates={scrollStates}
                      setScrollStates={setScrollStates}
                      virtualizeRef={virtualizeRef}
                      massiveSelectionHandler={recursivelySelection}
                      setMassiveSelection={setMassiveSelection}
                      resizing={resizing}
                      tableMetadata={tableConfig}
                      key={key}
                      lastLvlActivity={item}
                      index={key}
                      toSelectResponsables={toSelectResponsables}
                      handleAddConstraint={handleAddConstraint}
                      subContracts={subContracts}
                      setActivityResource={setActivityResource}
                      setTaskSelected={setTaskSelected}
                      setVisibleFormSubcontract={setVisibleFormSubcontract}
                      showDrawer={showDrawer}
                      onCloseCard={onCloseCard}
                      deleteSubcontract={deleteSubcontract}
                      calculateLeanStatus={calculateLeanStatus}
                      setVisibleFormResource={setVisibleFormResource}
                      setTypeResource={setTypeResource}
                      setVisibleFormTags={setVisibleFormTags}
                      toSelectTags={toSelectTags}
                    />
                  );
                }
              }}
              perPage={1}
            />
          )}
        </div>
      );
    }

    return (
      <div
        className={cn({
          'activity-pane__container':
            isFeatureOn('enable-LWP-103') &&
            activeActivityTreePane &&
            !isLoading
        })}>
        {isFeatureOn('enable-LWP-103') &&
          activeActivityTreePane &&
          !isLoading && (
            <ActivityTreePane
              activities={activitiesTreePanel}
              actitySettings={defaultView.current.activityTreeSettings}
              closePane={setActiveActivityTreePane}
              filterSettings={filterSettings}
              onCommandDispach={getLookahead}
              viewId={defaultView.current.id}
              setActivityTreePaneSettings={setActivityTreePaneSettings}
              isReloadDataViews={isReloadDataViews}
              t={t}
              currentActivityHidden={currentActivityHidden}
            />
          )}
        <CustomPaginator
          scrollStates={scrollStates}
          totalTablesWidth={totalTablesWidth}
          massiveSelection={massiveSelection}
          itemSize={height < 700 ? height * 0.55 : height * 0.68}
          current={currentPage}
          setCurrentPage={setCurrentPage}
          data={array}
          isFilterdData={existFilter}
          t={t}
          renderItem={(item, key, virtualizeRef) => {
            if (key == 0) {
              paginatorRef = virtualizeRef;
              return item;
            } else if (!resizing) {
              window.rowsActivities &&
                window.rowsActivities.resetAfterRowIndex(0);
              return (
                <LookaheadOtherGroup
                  subtradeRole={subtradeRole}
                  t={t}
                  permission={permission}
                  lookaheadActions={lookaheadActions}
                  ganttAPI={ganttAPI}
                  updateAsyncTask={updateAsyncTask}
                  updateAsyncActivity={updateAsyncActivity}
                  scrollStates={scrollStates}
                  isFilterdData={existFilter}
                  setScrollStates={setScrollStates}
                  virtualizeRef={virtualizeRef}
                  lastLvlActivity={item}
                  data={activities}
                  updateRender={updateRender}
                  massiveSelectionHandler={recursivelySelection}
                  setMassiveSelection={setMassiveSelection}
                  tableMetadata={tableConfig}
                  groupParent={item}
                  index={key}
                  key={key}
                  showDrawer={showDrawer}
                  lastLevelActivities={lastLevelActivitiesCard}
                  onCloseCard={onCloseCard}
                  toSelectResponsables={toSelectResponsables}
                  handleAddConstraint={handleAddConstraint}
                  subContracts={subContracts}
                  setVisibleFormSubcontract={setVisibleFormSubcontract}
                  groupBy={groupBy}
                  setVisibleFormTags={setVisibleFormTags}
                  toSelectTags={toSelectTags}
                />
              );
            }
          }}
          perPage={1}
        />
      </div>
    );
  };

  const renderGanttView = (propsTimelineView, filterSettings, setActivitiesHidden, currentActivityHidden, setCurrentActivityHidden) => {
    return (
      <Row>
        <Col
          style={{ height: height - 222 }}
          className={cn({
            'activity-pane__container':
              isFeatureOn('enable-LWP-103') &&
              activeActivityTreePane &&
              !isLoading
          })}>
          {isFeatureOn('enable-LWP-103') &&
            activeActivityTreePane &&
            !isLoading && (
              <ActivityTreePane
                activities={activitiesTreePanel}
                actitySettings={defaultView.current.activityTreeSettings}
                closePane={setActiveActivityTreePane}
                filterSettings={filterSettings}
                onCommandDispach={getLookahead}
                viewId={defaultView.current.id}
                setActivityTreePaneSettings={setActivityTreePaneSettings}
                isReloadDataViews={isReloadDataViews}
                t={t}
                currentActivityHidden={currentActivityHidden}
              />
            )}
          {isReloadDataViews && (
            <div>
              <Spin
                className="loader-spinner-lookahead-table"
                indicator={antIcon}
              />
            </div>
          )}

          {!isReloadDataViews && <GanttVisualization {...propsTimelineView} defaultView={defaultView.current} setActivitiesHidden={setActivitiesHidden} setCurrentActivityHidden={setCurrentActivityHidden} />}
        </Col>
      </Row>
    );
  };

  const renderTaktView = (filterSettings) => (
    <Row>
      <Col
        style={{ height: height - 192 }}
        className={cn({
          'activity-pane__container':
            isFeatureOn('enable-LWP-103') &&
            activeActivityTreePane &&
            !isLoading
        })}>
        {isFeatureOn('enable-LWP-103') &&
          activeActivityTreePane &&
          !isLoading && (
            <ActivityTreePane
              activities={activitiesTreePanel}
              actitySettings={defaultView.current.activityTreeSettings}
              closePane={setActiveActivityTreePane}
              onCommandDispach={getLookahead}
              filterSettings={filterSettings}
              viewId={defaultView.current.id}
              setActivityTreePaneSettings={setActivityTreePaneSettings}
              isReloadDataViews={isReloadDataViews}
              t={t}
              currentActivityHidden={currentActivityHidden}
            />
          )}
        {isReloadDataViews && (
          <div>
            <Spin
              className="loader-spinner-lookahead-table"
              indicator={antIcon}
            />
          </div>
        )}
        {!isReloadDataViews && (
          <TaktVisualization
            scrollTaktPosition={scrollTaktPosition}
            setScrollTaktPosition={setScrollTaktPosition}
            onDoubleClickTask={onDoubleClickTask}
            ganttAPI={ganttAPI}
            groupByActivity={groupBy.criteria == 'activityId'}
            taktRelations={taktRelations}
            handleUnfit={handleUnfit}
            permission={permission}
            handleAddConstraint={handleAddConstraint}
            markersDates={dateRange}
            actions={lookaheadActions}
            stateToExtract={'lookaheadState'}
            data={activities}
            subContracts={subContracts}
            t={t}
            history={history}
            updateRender={updateRender}
            tableConfig={tableConfig}
          />
        )}
      </Col>
    </Row>
  );

  /********************/
  /** Render section */
  /******************/

  /** This function defines current view type and renders that component */
  const renderVisualization = () => {
    const activityTreeSettings =
      defaultView.current?.activityTreeSettings?.filters?.values || false;
    const filterSettings = [
      {
        name: 'status',
        filter_by: activityTreeSettings
          ? activityTreeSettings.find((filter) => filter.name == 'status')
            .filter_by
          : [],
        values:
          tableConfig.filter((data) => data.name == 'status')[0]?.from_values ||
          [],
        type: 'icon'
      },
      {
        name: 'toSelectResponsibles',
        filter_by: activityTreeSettings
          ? activityTreeSettings.find(
            (filter) => filter.name == 'toSelectResponsibles'
          )?.filter_by
          : [],
        values: toSelectResponsables,
        type: 'image'
      },
      {
        name: 'subtrade',
        filter_by: activityTreeSettings
          ? activityTreeSettings.find((filter) => filter.name == 'subtrade')
            ?.filter_by
          : [],
        values: subContracts, // tableConfig.filter(data => data.name == 'subcontractId')[0]?.from_values || [],
        type: 'icon'
      },
      {
        name: 'tags',
        filter_by: activityTreeSettings
          ? activityTreeSettings.find((filter) => filter.name == 'tags')
            ?.filter_by
          : [],
        values: tags,
        type: 'string'
      }
    ];
    const propsTimelineView = {
      setGanttLoaded,
      listViews: listView,
      gantt,
      handleUnfit,
      permission,
      handleAddConstraint,
      markersDates: dateRange,
      onDoubleClickTask,
      actions: lookaheadActions,
      stateToExtract: 'lookaheadState',
      data: ganttData,
      subContracts,
      t,
      activities,
      setActivities,
      updateGanttVisualizationState,
      setVisibleFormSubcontract,
      toSelectResponsables,
      ganttAPI,
      updateAsyncActivity,
      updateAsyncTask,
      updateRender,
      groupBy,
      massiveSelectionHandler: recursivelySelection,
      lastLevelActivities: lastLevelActivitiesCard,
      loadStoredGroupQuery,
      massiveSelectionGannt,
      setMassiveSelectionGannt,
      tableConfig,
      massiveSelection,
      deleteSubcontract,
      modalModification,
      setModalModification,
      showDrawer,
      resizeColumnsTimeLine,
      saveColumnOrderTimeline,
      setVisibleFormResource,
      setTypeResource,
      setVisibleFormTags,
      toSelectTags,
      setActivityResource,
      toSelectSubs: subContracts,
      materials: resourceOptions.materials,
      specialties: resourceOptions.specialties,
      machineries: resourceOptions.machineries,
      colorSchema: defaultView.current.colorSchema || 'subcontract',
      setIsWeeklyCommited,
      isWeeklyCommited,
      volatileTaskData,
      customHour,
      isShowPreview,
      setMassiveSelection
    };
    const renderView = {
      table: (_) => renderTableView(filterSettings),
      gantt: (_) => renderGanttView(propsTimelineView, filterSettings, setActivitiesHidden, currentActivityHidden, setCurrentActivityHidden),
      takt: (_) => renderTaktView(filterSettings)
    };
    window.loader.hide();
    return renderView[defaultView.current.name]();
  };

  /** This function render the table with activities and their tasks */
  const renderTable = () => {
    if (isLoading) {
      return (
        null
      );
    }

    const activityTreeSettings =
      defaultView.current?.activityTreeSettings?.filters?.values || false;
    const filterSettings = [
      {
        name: 'status',
        filter_by: activityTreeSettings
          ? activityTreeSettings.find((filter) => filter.name == 'status')
            .filter_by
          : [],
        values:
          tableConfig.filter((data) => data.name == 'status')[0]?.from_values ||
          [],
        type: 'icon'
      },
      {
        name: 'toSelectResponsibles',
        filter_by: activityTreeSettings
          ? activityTreeSettings.find(
            (filter) => filter.name == 'toSelectResponsibles'
          )?.filter_by
          : [],
        values: toSelectResponsables,
        type: 'image'
      },
      {
        name: 'subtrade',
        filter_by: activityTreeSettings
          ? activityTreeSettings.find((filter) => filter.name == 'subtrade')
            ?.filter_by
          : [],
        values:
          tableConfig.filter((data) => data.name == 'subcontractId')[0]
            ?.from_values || [],
        type: 'icon'
      },
      {
        name: 'tags',
        filter_by: activityTreeSettings
          ? activityTreeSettings.find((filter) => filter.name == 'tags')
            ?.filter_by
          : [],
        values: tags,
        type: 'string'
      }
    ];

    const EmptyActivities = () => {
      window.loader.hide()
      return (
        <div
          className={cn({
            'activity-pane__container':
              isFeatureOn('enable-LWP-103') &&
              activeActivityTreePane &&
              !isLoading
          })}>
          {isFeatureOn('enable-LWP-103') &&
            activeActivityTreePane &&
            !isLoading && (
              <ActivityTreePane
                activities={activitiesTreePanel}
                actitySettings={defaultView.current.activityTreeSettings}
                closePane={setActiveActivityTreePane}
                filterSettings={filterSettings}
                onCommandDispach={getLookahead}
                viewId={defaultView.current.id}
                setActivityTreePaneSettings={setActivityTreePaneSettings}
                isReloadDataViews={isReloadDataViews}
                t={t}
                currentActivityHidden={currentActivityHidden}
              />
            )}
          <Empty
            style={{ marginTop: 200 }}
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={<span>{t('no_find_tasks')}</span>}
          />
        </div>
      )
    };

    if (activities.length) {
      // eslint-disable-next-line no-prototype-builtins
      if (
        groupBy.criteria !== 'activityId' &&
        !activities[0].hasOwnProperty('value')
      ) {
        return (
          <Spin
            className="loader-spinner-lookahead-table"
            indicator={antIcon}
          />
        );
      }
      return renderVisualization();
    }

    return <EmptyActivities />;
  };

  /** This function render the header with titles for the printed tables, it allows to drag n drop the position as also allow to resize the width. */
  const renderGeneralHeader = () => {
    if (isLoading) {
      return null;
    } else {
      return (
        <Row className="fixed-tree-table-header">
          <AnimatedSortable
            useDragHandle
            items={tableConfig}
            onSortEnd={moveCard}
            axis="x"
            onDivResizeHandler={onDivResizeHandler}
            onDivResizeDoubleClicked={onDivResizeDoubleClicked}
          />
        </Row>
      );
    }
  };

  /** This function render modal to create new constraint */
  const renderFormConstraints = () => {
    return (
      <ConstraintForm
        t={t}
        initialTasks={visibleForm.tasks}
        visibleForm={visibleForm.value}
        setVisibleForm={(val) => setVisibleForm({ value: val, tasks: [] })}
        toSelectResponsables={toSelectResponsables}
        setConstraintAdded={(updatedTasks) => handleUpdatedTasks(updatedTasks)}
      />
    );
  };

  const renderModalAddTags = (_) => (
    <ModalAddTags
      t={t}
      Visible={visibleFormTags}
      setVisible={setVisibleFormTags}
      setReloadTableUsers={setReloadTagsArray}
      ReloadTableUsers={reloadTagsArray}
    />
  );

  /** This function render modal to create new subs */
  const renderFormAddSubContracts = () => (
    <ModalAddSubContract
      t={t}
      Visible={visibleFormSubcontract}
      typeResource={typeResource}
      setVisible={setVisibleFormSubcontract}
      setReloadTableUsers={setReloadTagsArray}
      // setReloadTableUsersSub={setReloadTableUsers}
      setSubcontractsReload={setSubcontractsReload}
    />
  );

  /** This function render modal to create new resources */
  const renderFormAddResources = () => (
    <ModalAddResources
      t={t}
      typeResource={typeResource}
      Visible={visibleFormResource}
      setVisible={setVisibleFormResource}
      setReloadTableUsers={setReloadTableUsers}
      activityResource={activityResource}
      setLastLevelActivities={setLastLevelActivitiesCard}
      lastLevelActivities={lastLevelActivitiesCard}
      resourceAdded={(resource) => {
        if (defaultView.current.name === 'gantt')
          return setRefreshResourceForGantt(!refreshResourceForGantt);
        let resourceRoute;
        switch (typeResource) {
          case 'material':
            resourceRoute = 'materialId';
            break;
          case 'rrhh':
            resourceRoute = 'specialtyId';
            break;
          case 'machinery':
            resourceRoute = 'machineId';
            break;
          default:
            resourceRoute = 'materialId';
            break;
        }
        const doesExistAtReference = getTask(
          taskSelected.id,
          null,
          activityResource
        );
        if (doesExistAtReference[0]) {
          const reference = doesExistAtReference[0];
          reference[resourceRoute] = resource.id;
        }
        const saveObject = {
          ...taskSelected,
          [resourceRoute]: resource.id
        };
        updateAsyncTask(saveObject);
        const copy = cloneDeep(taskSelected);
        socket.emit('task_update', {
          sector: projectState.sectorSelected,
          task: copy
        });
      }}
      assignResourceOnCreate={true}
    />
  );

  /** This function render filter header which allows to switch between view types, and groupping, sorting, ordering or filtering data, as well a searchbar and other options */
  const renderFilterHeader = () => {
    if (isLoading) {
      return null;
    } else {
      const groupQuery = groupBy;
      return (
        <Row>
          <Col>
            <LookaheadFilterHeader
              setDateRange={setDateRange}
              viewType={viewType}
              viewService={viewService}
              isPlanification
              disableColumnsSelector={defaultView.current?.name == 'takt'}
              currentProject={projectState.allProjects.find(
                (el) => el.id === projectState.projectSelected
              )}
              isWeeklyCommited={isWeeklyCommited}
              ganttDhtmlx={gantt}
              visualizationOp={defaultView.current}
              updateDefaultViewFilters={updateDefaultViewFilters}
              defaultView={defaultView.current}
              defaultOrderOptions={[
                {
                  name: 'activityId',
                  label: t('activity_id'),
                  switch: ['1 → 9', '9 → 1']
                }
              ]}
              renderExtraFilterRigth={renderExtraItemsFilter}
              lookaheadActions={lookaheadActions}
              lookaheadState={'lookaheadState'}
              groupBy={groupQuery}
              setIsFilter={setExistFilter}
              modifyGroupBy={modifyGroupBy}
              data={activities}
              dateReportActive={activeLookAheadReportModal}
              exportPDFGantt={activeExportPdfModal}
              lastLevelActivities={lastLevelActivitiesCard}
              changeDateState={changeDateState}
              dateRange={dateRange}
              updateTableMetadata={updateTableMetadata}
              tableMetadata={
                defaultView.current?.columns_json?.settings || tableConfig
              }
              subContracts={subContracts}
              toSelectResponsables={toSelectResponsables}
              toSelectTags={toSelectTags}
              updateRender={updateRender}
              gantt={gantt}
              changeVisualization={changeVisualizationHandle}
              listViews={listView}
              resources={resourcesCard}
              setActiveActivityTreePane={setActiveActivityTreePane}
              activitiTreePane={activeActivityTreePane}
              setIsShowPreview={setIsShowPreview}
              place={'lookahead'}
              activitiesHidden={activitiesHidden}
            />
          </Col>
        </Row>
      );
    }
  };

  /** This function render massive action header when clicking at checkbox */
  const renderMassiveActionHeader = () => {
    if (isLoading) {
      return null;
    } else if (tableUpdated && tableConfig.length) {
      if (defaultView.current.name == 'gantt') {
        return (
          <MassiveTimelineView
            massiveSelection={massiveSelection}
            massiveOnProcess={massiveOnProcess}
            t={t}
            massiveConstraintHandler={massiveConstraintHandler}
            groupBy={groupBy}
            getActivityAndParentReference={getActivityAndParentReference}
            defaultView={defaultView}
            updateAsyncTask={updateAsyncTask}
            activities={activities}
            tableConfig={tableConfig}
            tableMetadata={availableTableMetadata}
            updateAsyncActivity={updateAsyncActivity}
            projectState={projectState}
            updateRender={updateRender}
            updateGanttVisualizationState={updateGanttVisualizationState}
            notifyMessage={notifyMessage}
            setMassiveSelection={setMassiveSelection}
            handlePopVisibility={handlePopVisibility}
            loadStoredGroupQuery={loadStoredGroupQuery}
            massiveSelectionGannt={massiveSelectionGannt}
            setMassiveSelectionGannt={setMassiveSelectionGannt}
            toSelectResponsables={toSelectResponsables}
            subContracts={subContracts}
            dateRange={dateRange}
            getLookaheadInMassive={getLookaheadInMassive}
            ganttAPI={ganttAPI}
            sectorObject={sectorObject}
          />
        );
      }
    }
  };


  /** These functions render PDF report from lookaheadheader */
  const handleCloseModal = () => {
    trackingEvent(
      'lookahead_pdf_export_cancelation',
      {
        ...getBasicAmplitudEventProperties(),
        start_date_selected: modelReportDateLookAhead,
        weeks_number_selected: numWeeks
      },
      AMPLITUDE_SERVICE
    );
    setLoadingPdf(false);
    setModelReportLookAhead(!modelReportLookAhead);
  };

  const printDateSelectOption = () => {
    const dateFormatDefault = 'YYYY/MM/DD';
    const formatGantt =
      window.ganttVisualization?.currentDateFormat || dateFormatDefault;
    const formatCorrect = formatGantt.split(' ')[0];
    return (
      <div className="option-print--datepicker">
        <label>{t('export_lookahead_pdf_modal.start_date')}</label>
        <div className="select__picker">
          {DatePickerSystem({
            theme: 'dark',
            format: formatCorrect,
            defaultValue: moment(new Date(), formatCorrect),
            defaultPickerValue: moment(new Date(), formatCorrect),
            allowClear: false,
            onChange: (_date) => dateReportHandle(_date),
            isError: isErrorForm
          })}
        </div>
      </div>
    );
  };

  const generateWeekItems = () => {
    const numWeeksRange = Array.from({ length: 8 }, (_, index) => index + 1);

    return numWeeksRange.map((value) => ({
      key: value,
      label: `${value} ${value === 1 ? t('export_lookahead_pdf_modal.week') : t('export_lookahead_pdf_modal.weeks')}`,
      onClick: () => handleInputChange(value),
      disabled: false,
      isDivider: false,
      active: value === numWeeks,
      subitems: []
    }));
  };

  const printNumWeeksOption = () => {
    return (
      <div className="option-print--weeks">
        <label>{t('export_lookahead_pdf_modal.num_weeks')}</label>
        <div className="format__dropdown">
          {DropdownSystem({
            theme: 'dark',
            version: 'v2',
            trigger: ['click'],
            height: 32,
            label: `${numWeeks} ${numWeeks === 1 ? t('export_lookahead_pdf_modal.week') : t('export_lookahead_pdf_modal.weeks')}`,
            withRadioButtons: false,
            items: generateWeekItems(),
            isError: isErrorForm
          })}
        </div>
      </div>
    );
  };

  const contentModal = () => {
    return (
      <div className="modal--export--pdf">
        {isShowAlertEmpty && (
          <div className="modal--export--pdf__alert">
            <div className="alert__icon">
              <WarningDiamontIcon color="#FDD551" />
            </div>
            <div className="alert__text">
              <p>{t('export_lookahead_pdf_modal.alert_text')}</p>
            </div>
          </div>
        )}
        <div className="modal--export--pdf__description">
          <label>{t('export_lookahead_pdf_modal.description')}</label>
        </div>
        <div className="modal--export--pdf__options">
          {printDateSelectOption()}
          {printNumWeeksOption()}
        </div>
        <div className="modal--export--pdf__footer">
          <button className="footer__cancel" onClick={() => handleCloseModal()}>
            {t('cancel')}
          </button>
          <button
            className="footer__download"
            disabled={isLoadingPdf}
            onClick={validateAndNavigate}
            key="submit"
            style={{
              background: '#7DFF8A',
              color: '#121212',
              borderColor: '#7DFF8A'
            }}>
            {isLoadingPdf ? (
              <Spin indicator={antIcon} className="download__spinner" />
            ) : (
              t('export_lookahead_pdf_modal.generate')
            )}
          </button>
        </div>
      </div>
    );
  };

  const renderReportModal = () => {
    return ModalSystem({
      theme: 'dark',
      width: 480,
      title: t('export_lookahead_pdf_modal.title'),
      showIconTitle: true,
      iconTitle: <PdfIcon color="#7DFF8A" />,
      visible: modelReportLookAhead,
      setVisible: setModelReportLookAhead,
      centered: true,
      children: contentModal(),
      onCancelFunction: () => {
        handleCloseModal();
      }
    });
  };

  const renderExportPdfModal = () => {
    return (
      <ExportPdfModal
        t={t}
        isSchedule={false}
        isVisible={isExportPdfModalVisible}
        setIsVisible={setIsExportPdfModalVisible}
        handleClose={() => setIsExportPdfModalVisible(false)}
        openFitToOnePageModal={() => setIsShowFitToOnePageModal(true)}
      />
    )
  };

  const renderFitToOnePageModal = () => {
    return (
      <ModalMessage
        t={t}
        isShow={isShowFitToOnePageModal}
        setIsShow={setIsShowFitToOnePageModal}
      />
    )
  };

  /** This function render modal which deal with the unfit activity modification request */
  const renderActivityModificationModal = () => {
    return (
      <Modal
        wrapClassName="activity-modification-style"
        title={modalModification.title}
        visible={modalModification.visible}
        onCancel={() =>
          setModalModification({ ...modalModification, visible: false })
        }
        footer={[
          <Button
            onClick={() =>
              createActivityModificationRequest(
                modalModification.data.task,
                modalModification.data.activity
              )
            }
            key="submit"
            style={{
              background: '#7DFF8A',
              color: '#121212',
              borderColor: '#7DFF8A'
            }}>
            {t('modals.lookahead.activity_modification_request.send_request')}
          </Button>
        ]}>
        {modalModification.visible ? (
          <div>
            <div>
              <span className="name-activity-modification">
                {modalModification.data.activity.name}
              </span>
            </div>
            <div className="dates-container-activity-modification">
              <span className="calendar-activity-modification">
                <img src={calendarModificationIconModal} width={12} />
              </span>
              <span className="dates-activity-modification">
                {modalModification.data.activity.start_date.split(' ')[0]}
              </span>
              <span className="calendar-activity-modification">
                <img src={calendarModificationIconModal} width={12} />
              </span>
              <span className="dates-activity-modification">
                {modalModification.data.activity.end_date.split(' ')[0]}
              </span>
            </div>
            <div className="modification-title-activity-modification">
              {defineTitleModification(modalModification.data.task, t)}
            </div>
            {defineDateUnfit(
              modalModification.data.task,
              modalModification.data.activity,
              t
            )}
            <div className="commentary-container-activity-modification">
              {t('modals.lookahead.activity_modification_request.comment')}
            </div>
            <div>
              <TextArea
                onChange={({ target: { value } }) => {
                  modalModification.description = value;
                }}
                placeholder={t(
                  'modals.lookahead.activity_modification_request.description_placeholder'
                )}
                autoSize={{ minRows: 2, maxRows: 6 }}
              />
            </div>
          </div>
        ) : null}
      </Modal>
    );
  };

  /** This function render the card content to be displayed when clicking some task */
  const renderCardTaskModal = () => {
    if (cardState) {
      return (
        <CardTask
          gantt={gantt}
          updateRender={updateRender}
          activities={activities}
          currentTask={currentTask}
          currentActivity={currentActivity}
          cardState={cardState}
          subContracts={subContracts}
          tableConfig={tableConfig}
          lastLevelActivities={lastLevelActivitiesCard}
          onCloseCard={onCloseCard}
          handshake={handshake}
          toSelectResponsables={toSelectResponsables}
          resources={resourcesCard}
          updateAsyncTask={updateAsyncTask}
          handlePopVisibility={handlePopVisibility}
          popsVisibility={popsVisibility}
          handlePopVisibilityCloseAll={handlePopVisibilityCloseAll}
          t={t}
          permission={permission}
          belongsToRange={belongsToRange}
          dateRange={dateRange}
          setVisibleFormSubcontract={setVisibleFormSubcontract}
          excludeDeep={excludeDeep}
          currentWeekWithPday={currentWeekWithPday}
          updateAsyncActivity={updateAsyncActivity}
          updateResources={updateResources}
          getTask={getTask}
          excludeAfterAction={false}
          deleteSubcontract={deleteSubcontract}
          groupBy={groupBy}
          currentViewLookahead={defaultView}
        />
      );
    }
  };

  /** This function render all described modals used at this view */
  const renderModals = () => {
    return (
      <>
        {renderModalAddTags()}
        {renderFormConstraints()}
        {renderFormAddSubContracts()}
        {renderReportModal()}
        {renderExportPdfModal()}
        {renderFitToOnePageModal()}
        {renderCardTaskModal()}
        {renderFormAddResources()}
        {renderActivityModificationModal()}
        {refresh ? <div /> : null}
      </>
    );
  };

  /** This function defines if user has correct permission to visualize the view content */
  const renderWithPermission = () => {
    if (permission == 'ACP' || permission == 'AC' || permission == 'V') {
      return (
        <Animated
          animationIn="fadeIn"
          animationInDuration={500}
          isVisible={true}>
          <Row>
            <Col className="lookahead-view">
              {renderFilterHeader()}
              <div className='toolbar-wrapper'>
                {renderMassiveActionHeader()}
              </div>
              {renderTable()}
            </Col>
          </Row>
          {renderModals()}
        </Animated>
      );
    } else {
      return <div>{t('settings.not_permissions')}</div>;
    }
  };

  /**
   * Render
   */
  return (
    <div data-testid={TestIds.PLANIFICATION_CONTAINER}>
      {renderWithPermission()}
    </div>
  );
}

const memoizedComponent = PlanificationView;
export default withTranslation()(memoizedComponent);
